{
  "common": {
    "add": "Add",
    "all": "All",
    "apply": "Apply",
    "back": "Back",
    "batchCreate": "Batch Create",
    "cancel": "Cancel",
    "clear": "Clear",
    "clearAll": "Clear All",
    "close": "Close",
    "columnValues": {
      "basicInfo": "Basic Info",
      "bindTime": "Assignment Time",
      "createBy": "Created By",
      "createTime": "Create Time",
      "description": "Description",
      "id": "ID",
      "operation": "Operation",
      "remark": "Remark",
      "status": "Status",
      "updateTime": "Update Time"
    },
    "confirm": "Confirm",
    "copy": "Copy",
    "create": "Create",
    "delete": "Delete",
    "detail": "Detail",
    "dialogTitles": {
      "addTitle": "Add",
      "confirmDelete": "Confirm Delete",
      "deleteTitle": "Delete Confirmation",
      "editTitle": "Edit",
      "reminder": "Reminder"
    },
    "export": "Export",
    "exportSuccess": "Export Success",
    "hide": "Hide",
    "http": {
      "getLocaleFailed": "Failed to get locale settings, using default language:",
      "insufficientPermission": "Insufficient permissions, please log in again",
      "loginExpired": "Oops, your session has timed out, please login again",
      "requestFailed": "Request failed",
      "systemPrompt": "Just a Note"
    },
    "inputPlaceholder": "Please enter",
    "login": "Log in",
    "loginOut": "Log out",
    "messages": {
      "addFailed": "Couldn't Create",
      "addSuccess": "Created!",
      "deleteConfirm": "Are you sure you want to delete?",
      "deleteFailed": "Couldn't delete",
      "deleteSuccess": "Deleted!",
      "editFailed": "Couldn't Save",
      "editSuccess": "Changes Saved",
      "formValidationFailed": "Form validation failed",
      "imageUploadFailed": "Image upload failed",
      "imageUploadSuccess": "Image upload successful",
      "loginOutMessage": "Are you sure you want to log out?",
      "operationFailed": "Operation failed",
      "resetPasswordFailed": "Password reset failed",
      "resetPasswordSuccess": "Password reset successful",
      "saveFailed": "Couldn't Save",
      "saveSuccess": "Saved !",
      "submitFailed": "Submit failed",
      "updateFailed": "Couldn't Update",
      "updateSuccess": "Updated !"
    },
    "no": "fail",
    "none": "None",
    "ok": "OK",
    "openInNewWindow": "Open in a new tab",
    "placeholders": {
      "enter": "Please enter {field}",
      "search": "Search {field}...",
      "select": "Please select {field}",
      "selectOrInput": "Please select or input {field}"
    },
    "register": "Sign up",
    "reset": "Reset",
    "save": "Save",
    "search": "Search",
    "selectAll": "Select All",
    "show": "Show",
    "statusValues": {
      "assignDevice": "Assign device",
      "assignQR": "Assign QR",
      "binded": "Assigned",
      "bound": "Assigned",
      "commandFailed": "Command Failed",
      "commandProgress": "Command Progress",
      "commandSuc": "Command Suc",
      "copyFailed": "Copy Failed",
      "copySuccess": "Copy Success",
      "disabled": "Disabled",
      "enabled": "Enabled",
      "error": "Error",
      "forbidden": "Not Active",
      "no": "No",
      "noData": "No Data",
      "none": "None",
      "normal": "Active",
      "notSet": "Not Set",
      "offline": "Offline",
      "online": "Online",
      "processing": "Processing",
      "shipped": "Shipped",
      "shippedFail": "Shipping Failed",
      "unShipped": "Unshipped",
      "unbind": "Not Assigned",
      "unbound": "Not Assigned",
      "unknown": "Unknown",
      "yes": "Yes"
    },
    "update": "Edit",
    "timeZone": "Time Zone",
    "validation": {
      "emailFormat": "Please enter a valid email address",
      "hyphenRequired": "{field} must contain a hyphen (-)",
      "invalidLocale": "{field} format is invalid. Please enter a valid locale code",
      "imageSizeLimit": "Image size must be less than 1MB",
      "lengthRange": "Length should be between {min} and {max} characters",
      "maxLength": "Length cannot exceed {max} characters",
      "minLength": "Length must be at least {min} characters",
      "onlyImageFiles": "Only image files are allowed",
      "passwordComplexity": "Include at least two types: letters, numbers, and symbols.",
      "passwordMismatch": "The two passwords do not match",
      "required": "Please enter {field}",
      "selectRequired": "Please select {field}",
      "urlFormat": "Please enter a valid URL address"
    },
    "version": "Version",
    "view": "View",
    "viewDetail": "View Detail",
    "yes": "success"
  },
  "dashboardPage": {
    "annualSalesComparison": "Annual Sales Comparison",
    "bottom5Performers": "Bottom 5 Performers",
    "bottom5WorstPerforming": "Bottom 5 Worst Performing",
    "cash": "Cash",
    "cashVsCashless": "Cash vs Cashless Income",
    "cashless": "Cashless",
    "cityMachineLocations": "Map",
    "clusterOffline": "Offline at this location",
    "clusterOnline": "Online at this location",
    "day": "Day",
    "displayBy": "Display by",
    "errorMachines": "Error",
    "errorMachinesShort": "Err",
    "errorStatus": "Error",
    "hour": "Hour",
    "income": "Income",
    "last12Months": "Last 12 Months",
    "last24H": "Last 24H",
    "last30Days": "Last 30 Days",
    "last7Days": "Last 7 Days",
    "last10Days": "Last 10 Days",
    "last10Mins": "Last 10 mins",
    "lastMonth": "Last Month",
    "lastPeriod": "Last Period",
    "lastUpdated": "Last Updated",
    "lastWeek": "Last Week",
    "lastYear": "Last Year",
    "loadMachineMapFailed": "Failed to load machine map data",
    "locationLabel": "Location",
    "machine": "Machine",
    "machineNoLabel": "Machine No.",
    "machinePrefix": "Machine #",
    "machines": "Galaxy",
    "mapInfoOffline": "Offline",
    "mapInfoOnline": "Online",
    "mapRetryLoad": "Retry loading map",
    "mapUnavailable": "Map unavailable",
    "month": "Month",
    "month1": "Jan",
    "month10": "Oct",
    "month11": "Nov",
    "month12": "Dec",
    "month2": "Feb",
    "month3": "Mar",
    "month4": "Apr",
    "month5": "May",
    "month6": "Jun",
    "month7": "Jul",
    "month8": "Aug",
    "month9": "Sep",
    "noMachineData": "No machine data available",
    "noPaymentData": "No payment data available",
    "officeBuildingA": "Office Building A",
    "offlineMachines": "Offline Machines",
    "onlineMachines": "Online Machines",
    "onlineStatus": "Online",
    "paymentMethod": "Payment Method",
    "paymentMethods": "Payment Methods",
    "revenue": "Revenue",
    "sales": "Sales",
    "salesTrendAnalysis": "Sales Trend Analysis",
    "saltLakeCityArea": "Salt Lake City Area",
    "searchFilter": "Search Filter",
    "searchMachines": "search galaxy...",
    "thisMonth": "This Month",
    "thisWeek": "This Week",
    "thisYear": "This Year",
    "title": "Dashboard",
    "today": "Today",
    "todayRevenue": "Today's Revenue",
    "todayVends": "Today's Vends",
    "top5BestPerforming": "Top 5 Best Performing",
    "top5Performers": "Top 5 Performers",
    "totalSalesToday": "Total Sales Today",
    "totalVendsToday": "Total Vends Today",
    "vends": "Vends",
    "weekDay1": "Mon",
    "weekDay2": "Tue",
    "weekDay3": "Wed",
    "weekDay4": "Thu",
    "weekDay5": "Fri",
    "weekDay6": "Sat",
    "weekDay7": "Sun",
    "weeklyComparison": "Weekly Comparison",
    "year": "Year",
    "yesterday": "Yesterday",
    "yesterdayRevenue": "Last Period's Revenue",
    "yesterdayVends": "Last Period's Vends"
  },
  "developmentCenter": {
    "addApiKey": "Add API Key",
    "addGatewayConfig": "Add Gateway Configuration",
    "apiKeyCreatedSuccess": "API Key created successfully!\nPassword: {password}",
    "apiKeyManagement": "OpenAPI Key Management",
    "apiName": "API Name",
    "apiNameLength": "API name length should be between 2 and 50 characters",
    "confirmDeleteApiKey": "Are you sure to delete API Key {apiName}?",
    "confirmDeleteGatewayConfig": "Are you sure to delete gateway config of org {orgName}?",
    "createSuccess": "Created successfully",
    "deleteApiKeyFailed": "Failed to delete API Key",
    "deleteGatewayConfigFailed": "Failed to delete gateway config",
    "description": "OpenAPI Gateway Configuration and API Key Management",
    "editApiKey": "Edit API Key",
    "editGatewayConfig": "Edit Gateway Configuration",
    "enterApiName": "Please enter API name",
    "enterGatewayUrl": "Please enter gateway URL",
    "enterSignKey": "Please enter sign key",
    "gatewayConfig": "OpenAPI Gateway Configuration",
    "gatewayType": "Gateway Type",
    "gatewayUrl": "Gateway URL",
    "help": {
      "apiName": "The name identifier of the API Key, used to identify and manage the API Key in the system, length 2-50 characters",
      "apiSignKey": "The signature key is used for API request signature verification to ensure the security and integrity of requests, length 8-100 characters",
      "cstatus": "API Key status, enabled API Keys can be used normally, disabled API Keys will be unable to make API calls",
      "gatewayOrgId": "Select the organization that owns this gateway configuration, the organization will use this gateway configuration for API calls, cannot be modified after creation",
      "gatewayStatus": "Gateway configuration status, enabled gateway configurations can be used normally, disabled gateway configurations will be unable to make API calls",
      "gatewayType": "Gateway type, select the type of API gateway, currently supports operational API type",
      "gatewayUrl": "Gateway URL address, used for API request routing and forwarding, must be a valid URL format",
      "orgId": "Select the organization that owns this API Key, the organization will have usage permissions for this API Key, cannot be modified after creation"
    },
    "loadApiKeysFailed": "Failed to load API Keys",
    "loadGatewayConfigsFailed": "Failed to load gateway configs",
    "loadOrgTreeFailed": "Failed to load organization tree",
    "operational": "Operational API",
    "operationalApi": "Operational API",
    "orgCode": "Organization Code",
    "orgType": "Organization Type",
    "organization": "Organization",
    "parentOrgNotFound": "Parent org ID: {sid} not found, treating org {label} as root node",
    "pleaseEnterApiName": "Please enter API name",
    "pleaseEnterSignKey": "Please enter sign key",
    "pleaseSelectOrg": "Please select organization",
    "pleaseSelectStatus": "Please select status",
    "resetPassword": "Reset Password",
    "selectGatewayType": "Please select gateway type",
    "selectOrganization": "Please select organization",
    "selectStatus": "Please select status",
    "signKey": "Sign Key",
    "signKeyLength": "Sign key length should be between 8 and 100 characters",
    "signKeyTip": "Sign key is used for API request signature verification",
    "submitFailed": "Submit failed",
    "title": "Development Center",
    "updateSuccess": "Updated successfully"
  },
  "error": {
    "mobileLayoutWarning": "Mobile mode does not support switching layouts",
    "networkError": "Oops, it seems like we have an error",
    "noPermission": "Oh oh, seems like you don't have enough permissions for this page",
    "pageError": "Ohh, that's strange, seems like the page you are trying to open doesn't exist",
    "returnToHome": "Return to home"
  },
  "fileUpload": {
    "delete": "Delete",
    "downloadFailed": "Download failed, please try again",
    "downloadSuccess": "Download successful",
    "exampleDownload": "Example Download",
    "exampleDownloadBtnName": "Device Batch Import Example.csv",
    "exampleDownloadTip": "Download the example file, fill in the device information according to the format, and then upload",
    "fileSizeLimit": "File size cannot exceed 2MB!",
    "fileTip": "Please upload Excel or CSV format files, size up to 2MB",
    "fileUpload": "File Upload",
    "invalidFileFormat": "Invalid file format, please upload Excel or CSV files!",
    "onlyExcelOrCsv": "Only Excel or CSV files are allowed!",
    "selectFile": "Select File"
  },
  "listFilter": {
    "cancel": "Cancel",
    "delete": "Delete",
    "deletedColumns": "Deleted Columns",
    "exportFailed": "Export failed, please try again",
    "noFilterItems": "No filter items",
    "reset": "Reset",
    "save": "Save",
    "saveFailed": "Save failed, please try again",
    "saveSuccess": "Save successful",
    "selectedColumns": "Selected Columns",
    "title": "List Filter"
  },
  "lock": {
    "backToLogin": "Back to login",
    "entrySystem": "Sign back in",
    "lockAction": "Lock",
    "lockPassword": "Lock screen password",
    "lockScreen": "Lock screen",
    "message": "Incorrect lock screen password",
    "placeholder": "Please enter your lock screen password",
    "unlock": "Click to unlock"
  },
  "loginPage": {
    "checkPassword": "Confirm Password",
    "code": "Verification Code",
    "copyright": "© 2026 Trilad Technology US LLC. All rights reserved.",
    "continueWithApple": "Continue with Apple",
    "continueWithGoogle": "Continue with Google",
    "hasUser": "Already have an account? Log in",
    "officialWebsite": "Official Website",
    "or": "or",
    "password": "Password",
    "remember": "Remember me",
    "subtitle": "Command Your Machine Universe",
    "username": "Username"
  },
  "myAccount": {
    "accountInfo": "Account Information",
    "backupEmail": "Backup Email",
    "basicInfo": "Basic Information",
    "belongingOrg": "Assigned Org",
    "changePassword": "Change Password",
    "companyName": "Company Name",
    "confirmPwd": "Confirm New Password",
    "createBy": "Created By",
    "createTime": "Create Time",
    "currentTimeZone": "Current Time Zone",
    "editPersonalProfile": "Edit Your Profile",
    "editProfile": "Edit Profile",
    "email": "Email",
    "enterCorrectMobile": "Please enter a valid mobile number",
    "firstName": "First Name",
    "fullName": "Full Name",
    "lastName": "Last Name",
    "lastUpdate": "Last Updated",
    "loadUserInfoFailed": "Failed to load user information",
    "loginAccount": "Username",
    "mobile": "Mobile",
    "myProfile": "My Profile",
    "newPwd": "New Password",
    "notSet": "Not Set",
    "oldPwd": "Current Password",
    "operatorName": "Operator Name",
    "passwordMismatch": "The two entered passwords are different",
    "personalInfo": "Personal Information",
    "preferences": "Preferences",
    "preferencesTabDescription": "Manage your time zone setting.",
    "profileTabDescription": "Manage your basic profile information.",
    "profileUpdateSuccess": "Info updated successfully",
    "pwdChangeFailed": "Fail to change password",
    "pwdChanged": "Your password has been changed",
    "role": "Role",
    "security": "Security",
    "securityTabDescription": "Update your login password.",
    "status": "Status",
    "language": "Language",
    "timeZone": "Time Zone",
    "title": "My Account",
    "titleLabel": "Title",
    "updateFailed": "Update failed, please double check the data entered",
    "updateFailedMissingId": "Update failed, missing operator ID"
  },
  "operationManagement": {
    "agencyManagement": {
      "addAgency": "Add Entity",
      "addSubAgency": "Add Sub Entity",
      "agencyCode": "Entity ID: ",
      "agencyTypes": {
        "branchAgent": "Distributor",
        "customer": "Operator",
        "factory": "Factory",
        "factoryAgent": "Factory Distributor",
        "plat": "Platform"
      },
      "basicInfoDetails": {
        "address": "Address",
        "agencyCode": "Entity ID",
        "agencyLogo": "Entity Logo",
        "agencyName": "Entity Name",
        "agencyType": "Entity Type",
        "contactEmail": "Contact Email",
        "contactPerson": "Contact Person",
        "contactPhone": "Contact Phone",
        "country": "Country",
        "culture": "Culture",
        "displayName": "Display Name",
        "email": "Email",
        "hasContract": "Agreement Signed?",
        "hasKyc": "KYC Passed?",
        "help": {
          "agencyLogo": "Upload entity logo, supports image files, recommended size 40x40px, maximum 1MB",
          "agencyName": "Entity name used to identify the entity, maximum 100 characters",
          "agencyType": "Select entity type, different entity types have different business rules and permissions",
          "country": "Select the country where the entity is located, this will automatically populate culture, language and timezone information",
          "culture": "Culture settings, automatically populated based on selected country, used for number and currency formats",
          "displayName": "Display name used to show the entity name in frontend interface, maximum 100 characters",
          "email": "Entity contact email for receiving system notifications, must be in valid email format",
          "hasContract": "Whether a contract has been signed, only required for customer type entities",
          "hasKyc": "Whether KYC account opening has been completed, only required for customer type entities",
          "language": "Language settings, automatically populated based on selected country, used for system interface display",
          "parentAgency": "Select parent entity, automatically determines if it is headquarters based on parent entity type",
          "status": "Select entity status, disabled entities will not be able to function normally",
          "taxRate": "Product tax rate, range 0-100, supports 2 decimal places, used for calculating product tax",
          "timezone": "Timezone settings, automatically populated based on selected country, used for time display and calculation"
        },
        "imageSizeLimit": "Image size cannot exceed 1MB!",
        "isHeadquarters": "Is Headquarters",
        "isHeadquartersTip": "(Auto-determined by parent entity type)",
        "language": "Language",
        "logoLoadFailed": "Couldn't load the logo, please try again",
        "logoTip": "Only Image files: PNG, JPEG/JPG; recommended size: 40x40px",
        "logoUploadFailed": "Couldn't upload",
        "logoUploadSuccess": "Logo uploaded!",
        "noLogo": "No logo here",
        "onlyImageFiles": "Only image files can be uploaded!",
        "parentAgency": "Parent Entity",
        "taxRate": "Tax Rate",
        "taxRateTip": "(Unit: %, Range: 0-100)",
        "timezone": "Timezone"
      },
      "deleteAgency": "Delete Entity",
      "editAgency": "Edit Entity",
      "email": "Email: ",
      "getOrgChildrenFailed": "Failed to load sub-organization list",
      "getOrgDetailFailed": "Failed to load organization details",
      "getOrgTreeListFailed": "Failed to load organization tree list",
      "messages": {
        "businessRules": {
          "addOperatorPasswordRequired": "Password is required for new operator",
          "branchAgentOnlyCustomerOrAgent": "Only customer or branch agent entity can be created under branch agents",
          "customerOnlyCustomer": "Only customer-type entity can be created under customers",
          "factoryAgentOnlyCustomerOrAgent": "Only customer or factory agent entity can be created under factory agents",
          "factoryOnlyFactory": "Only factory-type entity can be created under factories",
          "loadRolesFailed": "Failed to load role list",
          "platMustBeHeadquarters": "Platform entity must be headquarters",
          "subAgencyCannotBeHeadquarters": "Entities under other parents cannot be set as headquarters"
        },
        "cannotDeleteWithChildren": "This entity has sub-entities and cannot be deleted. Please delete all sub-entities first.",
        "confirmDeleteNoChildren": "Are you sure you want to delete entity \"{name}\"?",
        "confirmDeleteOperator": "Are you sure you want to delete user \"{name}\"?",
        "loadDataFailed": "Failed to load data",
        "loadingTree": "Loading organization tree..."
      },
      "operators": "Users",
      "operatorsDetails": {
        "addOperator": "Add User",
        "adminRole": "Admin",
        "auditorRole": "Approver",
        "backupEmail": "Backup Email",
        "companyName": "Entity Name",
        "customerServiceRole": "Customer Service",
        "editOperator": "Edit Entity",
        "emailLabel": "Email",
        "financeRole": "Finance",
        "firstName": "First Name",
        "help": {
          "backupEmail": "Operator backup email address for emergency contact, must be in valid email format",
          "companyName": "Company name of the operator, maximum 200 characters",
          "email": "Operator primary email address for receiving system notifications, must be in valid email format",
          "firstName": "Operator first name, maximum 50 characters",
          "lastName": "Operator last name, maximum 50 characters",
          "loginAccount": "Username for system login, can only contain letters, numbers and underscores, length 3-100 characters",
          "mobile": "Operator mobile number, maximum 50 characters",
          "operatorName": "Operator display name used to identify the operator in the system, maximum 100 characters",
          "password": "Login password, length 6-255 characters, it is recommended to use a combination of letters, numbers and special characters",
          "role": "Select the operator role, different roles have different system permissions",
          "status": "Select operator status, disabled operators will not be able to log in to the system",
          "titleLabel": "Operator position or title, maximum 50 characters"
        },
        "lastName": "Last Name",
        "loginAccount": "Username",
        "mobile": "Mobile",
        "operations": "Operations",
        "operatorName": "Operator Name",
        "operatorRole": "Operator",
        "operatorsCreateTime": "Create Time",
        "operatorsDelete": "Delete",
        "operatorsEdit": "Edit",
        "password": "Password",
        "passwordTip": "Password length 6-255 characters, it is recommended to use a combination of letters, numbers and special characters",
        "resetPassword": "Reset Password",
        "role": "Role",
        "title": "User Management",
        "titleLabel": "Title",
        "userType": "User Type"
      },
      "payChannels": {
        "addChannelConfig": "Add Payment Provider",
        "addToAgency": "Add to Entity",
        "apiKeySecurityWarning": "You are about to view sensitive API key information. Please confirm your operating environment is secure.",
        "availableChannels": "Available payment channels to add to entity",
        "channelConfig": "Payment Provider Configuration",
        "channelName": "Provider Name",
        "channelProducts": "Payment Providers",
        "channelReferencedWarning": "This provider is referenced by a package. Please remove it from the package first before deleting.",
        "configInfo": "Config Info",
        "configItemsIncomplete": "Please complete all config item fields",
        "configKeyDuplicate": "Config item keys cannot be duplicated",
        "configKeyPlaceholder": "Config key",
        "configValuePlaceholder": "Config value",
        "configuredChannels": "Entity configured payment providers",
        "currentConfiguredChannels": "Current entity configured payment providers",
        "deleteConfirmMessage": "Are you sure you want to delete this payment provider? This action cannot be undone.",
        "editChannelConfig": "Edit Payment Provider Config",
        "formMode": "Form Mode",
        "help": {
          "channelConfig": "Configure payment provider parameters, supports both form mode and JSON mode, fill in required parameters according to provider requirements",
          "channelName": "Payment provider name, automatically filled by the system and cannot be modified",
          "mdrVatRate": "MDR VAT rate, range 0-100, supports 2 decimal places, used for calculating MDR VAT",
          "mdrVatRateFixed": "MDR VAT Fixed Rate, supports 2 decimal places, used for calculating MDR VAT",
          "status": "Select provider status, disabled providers will not be available"
        },
        "jsonConfigPlaceholder": "Please enter JSON configuration...",
        "jsonFormatIncorrect": "Invalid JSON format",
        "jsonGenerateFailed": "Failed to generate JSON:",
        "jsonMode": "JSON Mode",
        "jsonParseFailed": "Failed to parse JSON:",
        "loadOrgChannelsFailed": "Failed to load organization payment channels:",
        "loadSystemChannelsFailed": "Failed to load system channels:",
        "mdrVatRate": "MDR VAT Rate",
        "mdrVatRateFixed": "MDR VAT Fixed Rate",
        "mdrVatRateTip": "(Unit: %, Range: 0-100)",
        "methodsCount": " channels",
        "noAvailableChannels": "No available channels to add",
        "noConfig": "it's all empty here…",
        "noConfigItems": "No config items yet, click Add above",
        "noConfiguredChannels": "No payment providers configured yet, please select from the left to add",
        "noProducts": "No Products, add some?",
        "parseChannelConfigFailed": "Failed to parse channel config:",
        "searchNoResults": "No results found, please try other keywords",
        "searchPlaceholder": "Search channel name or code",
        "securityConfirm": "Security Confirmation",
        "submitFormFailed": "Failed to submit form:",
        "systemChannelPool": "System Payment Providers",
        "toggleStatusConfirmMessage": "Are you sure you want to {action} payment provider \"{name}\"?",
        "toggleStatusConfirmTitle": "Confirm {action}",
        "toggleStatusSuccess": "{action} successful",
        "typeBoolean": "Boolean",
        "typeNumber": "Number",
        "typePlaceholder": "Type",
        "typeString": "String",
        "configWarningMsg": "Configuration information detected multiple asterisks, there may be configuration errors. Do you want to continue submitting?",
        "configWarningTitle": "Configuration may have errors"
      },
      "payChannelsTab": "Payment Provider",
      "payMethods": {
        "addFailed": "Add failed",
        "addToAgency": "Add to Entity",
        "availableMethods": "Available payment methods to add to entity",
        "configuredMethods": "Entity configured payment methods",
        "currentConfiguredMethods": "Current entity enabled payment methods",
        "deleteConfirmMessage": "Are you sure you want to delete this payment method configuration? This action cannot be undone.",
        "methodReferencedWarning": "This payment method is referenced by the following packages and cannot be deleted: ",
        "noAvailableMethods": "No available payment methods to add",
        "noConfiguredMethods": "No payment methods configured yet, please select from the left to add",
        "packageRefsCount": " package references",
        "searchNoResults": "No search results, please try other keywords",
        "searchPlaceholder": "Search payment method name or code",
        "systemPaymentMethods": "System Payment Methods",
        "toggleStatusConfirmMessage": "Are you sure you want to {action} payment method \"{name}\"?",
        "toggleStatusConfirmTitle": "Confirm {action}",
        "toggleStatusSuccess": "{action} successful"
      },
      "payMethodsTab": "Payment Method Configuration",
      "payPackages": {
        "addChannel": "Add Provide",
        "addChannelSuccess": "Add channel successful",
        "addChannelToPackage": "Add Channel to Package",
        "addMethod": "Add Method",
        "addMethodSuccess": "Add successful",
        "addPaymentMethod": "Add Payment Method",
        "amount": "Amount",
        "calculateFee": "Calculate Fee",
        "calculationResult": "Calculation Result",
        "channelConfiguration": "Channel Configuration",
        "channelOperationFailed": "Channel operation failed",
        "channelPaymentMethodConfiguration": "Preset Configuration",
        "cloneFailed": "Copy failed",
        "cloneSuccess": "Copy successful",
        "createPackage": "Create Preset",
        "createPackageDialog": "Add New Template",
        "createSuccess": "Created successfully",
        "currency": "Currency",
        "currencyLoadFailed": "Failed to load currencies",
        "dataLoading": "Data loading, please wait...",
        "deleteChannelConfirm": "Are you sure you want to delete this channel? Related payment method configurations will also be deleted.",
        "deleteChannelFailed": "Failed to delete channel",
        "deleteMethodConfirm": "Are you sure you want to delete this payment method configuration?",
        "deleteMethodFailed": "Failed to delete payment method",
        "deletePackageConfirm": "Are you sure you want to delete this template? This action cannot be undone.",
        "device": "Device",
        "editChannel": "Edit Provider",
        "editPackage": "Edit Package",
        "editPaymentMethod": "Edit Payment Method",
        "feePreview": "Fee Preview",
        "fixedFee": "Fixed Fee",
        "fixedFeeCannotBeNegative": "Fixed fee cannot be negative",
        "fixedRate": "Fixed Rate",
        "handlingFee": "Commission",
        "help": {
          "currency": "Select the currency supported by the template, which will be applied to all channels and payment methods in the template",
          "fixedFee": "Fixed fee, range ≥0, fixed commission charged per transaction",
          "maxAmount": "Maximum transaction amount for this preset; Machines assigned to this preset cannot have a higher price",
          "minAmount": "Minimum transaction amount for this preset; Machines assigned to this preset cannot have a lower price",
          "packageName": "Template name used to identify the template, maximum 100 characters",
          "packageType": "Select template type, device type for device payment scenarios, open API for API interface call scenarios",
          "paymentMethod": "Select payment method, only shows payment methods supported by the current channel",
          "platProduct": "Select the associated platform business product, which will limit channels to those associated with this product, required for device type",
          "ratePercentage": "Percentage rate, range 0-99.99, calculates commission as a percentage of transaction amount",
          "selectChannel": "Select channels from configured entity payment channels to add to the template, multiple selection allowed",
          "status": "Select template status, disabled templates will not be available"
        },
        "amountCannotBeNegative": "Amount cannot be negative",
        "maxAmount": "Maximum Amount",
        "maxAmountCannotBeLessThanMin": "Maximum amount cannot be less than minimum amount",
        "minAmount": "Minimum Amount",
        "minAmountCannotExceedMax": "Minimum amount cannot exceed maximum amount",
        "loadChannelMethodsFailed": "Failed to load channel payment methods",
        "loadChannelsFailed": "Failed to load channels",
        "loadCurrenciesFailed": "Failed to load currencies",
        "loadMethodsFailed": "Failed to load payment methods",
        "loadPackageChannelsFailed": "Failed to load template channels",
        "loadPackageMethodsFailed": "Failed to load template methods",
        "loadPackagesFailed": "Failed to load packages",
        "methodFormRefNotFound": "Oops, System Error {field}",
        "methodOperationFailed": "Payment method operation failed",
        "noAvailableChannels": "No available channels, please configure entity payment channels first",
        "noChannelConfiguration": "No provider configuration",
        "noChannelsInPackage": "No channels in this template, please click to add",
        "noMethodsInChannel": "No payment methods in this provider, please click to add",
        "noPackages": "No templates available, please click to create",
        "noPaymentMethodConfiguration": "No payment method configuration",
        "noPaymentMethodsInChannel": "No payment methods configured in this channel",
        "openApi": "Open API",
        "packageChannelConfiguration": "Preset Provide Configuration",
        "packageCode": "Template Code",
        "packageName": "Template Name",
        "packagePreview": "Package Preview",
        "packageType": "Template Type",
        "paymentConfigurationPackages": "Payment Presets",
        "paymentMethod": "Payment Method",
        "paymentMethodConfiguration": "Payment Method Configuration",
        "percentageRate": "Percentage Rate",
        "pleaseSelectChannel": "Please select a Provide",
        "pleaseSelectChannelFirst": "Please select a channel first",
        "pleaseSelectPackage": "Please select a template",
        "pleaseSelectPackageAndChannel": "Please select template and channel first",
        "pleaseSelectPackageFirst": "Please select a template first",
        "ratePercentage": "Rate (%)",
        "rateRange": "Rate must be between 0-99.99",
        "saveChannelFailed": "Failed to save channel",
        "saveFailed": "Save failed",
        "saveMethodFailed": "Failed to save payment method",
        "savePackageFailed": "Failed to save package",
        "selectAtLeastOneChannel": "Please select at least one channel",
        "selectChannel": "Select Channel",
        "selectPackageType": "Please select template type",
        "updateChannelSuccess": "Update channel successful",
        "updateMethodSuccess": "Update successful",
        "updateSuccess": "Update successful",
        "yourReceive": "Your receive"
      },
      "payPackagesTab": "Payment Presets",
      "resetPasswordDetails": {
        "confirmPassword": "Confirm Password",
        "newPassword": "New Password",
        "operator": "User",
        "resetPasswordOperator": "User",
        "title": "Reset Password"
      },
      "searchAgency": "Search Organization...",
      "selectAgencyToView": "Please select an organization from the left to view details",
      "title": "Hierarchy Management"
    },
    "machineTransferLog": {
      "endTime": "End Time",
      "enterOperator": "Enter operator",
      "enterSysMachineNo": "Enter system machine number",
      "loadDataFailed": "Failed to load data",
      "loadOrgTreeFailed": "Failed to load organization tree",
      "machineInfo": "Machine Info",
      "machineName": "Machine Name",
      "machineType": "Machine Type",
      "newOrg": "New Organization",
      "noErrorMessage": "No error message",
      "oldOrg": "Old Organization",
      "operateTime": "Operate Time",
      "operator": "Operator",
      "orgChange": "Organization Change",
      "orgMachineNoChange": "Org Machine No. Change",
      "selectEndTime": "Select end time",
      "selectNewOrg": "Select new organization",
      "selectOldOrg": "Select old organization",
      "selectStartTime": "Select start time",
      "startTime": "Start Time",
      "sysMachineNo": "System Machine No.",
      "title": "Machine Transfer Log",
      "transferReason": "Transfer Reason",
      "transferResult": "Transfer Result"
    },
    "operationMachineManagement": {
      "welcome": {
        "title": "Explore your Galaxy, manage your Machines",
        "selectOperator": "Select an operator (galaxy) from the left panel to view its sub-operators and machines.",
        "selectMachine": "Click on a machine to see details and configure settings.",
        "alternative": "Alternatively, you can",
        "createMachine": "Create a new machine"
      },
      "accessLogTitle": "Access Log",
      "accessStatus": "Access Status",
      "accessStatusIdle": "Idle",
      "accessStatusPlaying": "Inhibit",
      "activeTime": "Active Time(ms)",
      "addCurrencySymbol": "Currency Symbol",
      "addDeviceFailed": "Failed to add device",
      "addFavoriteFailed": "Failed to add to favorites",
      "addFavoriteSuccess": "Added to favorites successfully",
      "addMachine": "Add Machine",
      "addMachineFailed": "Failed to add machine",
      "addMachineFavoriteFailed": "Failed to add machine favorite",
      "addMachineFavoriteSuccess": "Machine favorite added successfully",
      "addMachineProtocolConfigFailed": "Failed to add machine protocol configuration",
      "addMachineProtocolConfigSuccess": "Machine protocol configuration added successfully",
      "addMachineSuccess": "Machine added successfully",
      "addMachineTransferLogFailed": "Failed to add machine transfer log",
      "addMachineTransferLogSuccess": "Machine transfer log added successfully",
      "addPrice": "Add Price",
      "addPriceDisabledTip": "Please complete Price 1 first",
      "addProtocol": "Add Protocol",
      "addProtocolConfig": "Add Protocol Configuration",
      "addTransfer": "Transfer Machine",
      "animationDuration": "Animation Duration",
      "animationPreview": "Animation Preview",
      "averageUnitPrice": "Average Unit Price",
      "basicConfig": "Basic Configuration",
      "basicTextSettings": "Basic Text Settings",
      "belongingOrg": "Parent Organization",
      "bindDevice": "Assign device",
      "bindFailed": "Assignment failed",
      "bindQr": "Assign QR",
      "bindSuccess": "Assignment successful",
      "bonusGames": "Bonus Games",
      "bonusText": "Bonus Text",
      "bound": "Assigned",
      "boundDevice": "Assigned Device",
      "viewDevice": "View Device",
      "boundQrCode": "Assigned QR Code",
      "cancelFavoriteFailed": "Failed to cancel favorite",
      "cancelFavoriteSuccess": "Cancel favorite successfully",
      "cannotFindFavoriteRecord": "Cannot find favorite record",
      "cannotGetDeviceId": "Cannot get device ID",
      "cannotGetDeviceInfo": "Cannot get device information",
      "cannotGetMachineId": "Cannot get machine ID",
      "cannotGetMachineNo": "Cannot get machine number",
      "cashAmount": "Cash Amount",
      "cashClearLog": "Cash Clear Log",
      "cashHandling": "Cash Setting",
      "cashLog": "Log",
      "cci": "CCI",
      "cciProtocol": "CCI Protocol",
      "checkDeviceStatusFailed": "Failed to check device status, please try again later",
      "china": "China",
      "choosePaymethodTitle": "Choose Payment Method Text",
      "choosePlanText": "Choose Plan Text",
      "providerName": "Payment provider",
      "selectProviderName": "Select payment provider",
      "chooseProgram": "Choose Program",
      "chooseProgramTitle": "Choose Program Title",
      "city": "City",
      "clearAmount": "Clear Amount",
      "clearCash": "Clear",
      "clearCashFailed": "Failed to clear cash",
      "clearCashSuccess": "Cash cleared successfully",
      "clearTime": "Clear Time",
      "cashProduct": "Product",
      "cashProductHint": "Reporting Display Name for Cash Transactions",
      "coinCount": "Coin Count(Units)",
      "coinValue": "Coin Value",
      "completed": "Completed",
      "configSummary": "Configuration Summary",
      "confirmCancelFavorite": "Confirm Cancel Favorite",
      "confirmCancelFavoritePrompt": "Are you sure you want to cancel favorite for machine {name}?",
      "confirmClearCash": "Confirm Clear",
      "confirmClearCashMessage": "Are you sure you want to clear the cash amount {amount}? This action cannot be undone.",
      "confirmDelete": "Confirm Delete",
      "confirmDeleteTransferPrompt": "Are you sure you want to delete this transfer record?",
      "confirmRemoveFavorite": "Confirm Remove Favorite",
      "confirmRemoveFavoriteMessage": "Are you sure you want to remove machine \"{machineName}\" from favorites?",
      "confirmUnbindDevice": "Confirm Device Unassignment",
      "confirmUnbindDeviceMessage": "Please confirm you want to unassign device \"{deviceSN}\" from machine \"{machineName}{machineNumber}\".",
      "copy": "Copy",
      "copyFailed": "Copy failed",
      "copySuccess": "Copy successful",
      "country": "Country",
      "createBy": "Created By",
      "currentFrame": "Current Frame",
      "deleteFailed": "Delete failed",
      "deleteMachineFailed": "Failed to delete machine",
      "deleteMachineFavoriteFailed": "Failed to delete machine favorite",
      "deleteMachineFavoriteSuccess": "Machine favorite deleted successfully",
      "deleteMachineProtocolConfigFailed": "Failed to delete machine protocol configuration",
      "deleteMachineProtocolConfigSuccess": "Machine protocol configuration deleted successfully",
      "deleteMachineSuccess": "Machine deleted successfully",
      "deleteMachineTransferLogFailed": "Failed to delete machine transfer log",
      "deleteMachineTransferLogSuccess": "Machine transfer log deleted successfully",
      "deleteProtocol": "Delete Protocol",
      "deleteProtocolConfirm": "Are you sure you want to delete protocol \"{name}\"?",
      "deleteSuccess": "Deleted successfully",
      "paymentSimulationMode": "Payment Simulation Mode",
      "paymentSimulationModeDesc": "Choose how payments will be simulated for this machine in Demo mode.",
      "paymentSimulationModeManualTitle": "Manual Scan & Pay Simulation",
      "paymentSimulationModeManualDesc": "This feature will allow users to get a dynamic QR on the terminal, scan with their phone to open a Trilad checkout page and press Pay to approve the payment on the phone.",
      "paymentSimulationModeAutoTitle": "Autopayment Simulation",
      "paymentSimulationModeAutoDesc": "Automatically simulate a successful payment after a countdown. No phone interaction is required.",
      "detectionMethod": "Detection Method",
      "detectionNone": "None",
      "detectionPulse": "Pulse",
      "deviceCount": "Device Count",
      "deviceCreateSuccess": "Machine created successfully",
      "deviceName": "Device Name",
      "deviceNotBound": "Device is not assigned, cannot perform free vend operation",
      "deviceOffline": "Device is offline, cannot perform output operation",
      "deviceProtocolConfig": "Machine Configuration",
      "deviceSn": "Device SN",
      "deviceStatusForbidden": "Machine status has been set to not active, this machine will not be able to perform payments",
      "deviceStatusNormal": "Device status has been restored to normal",
      "deviceType": "Device Type",
      "deviceUpdateSuccess": "Machine updated successfully",
      "dictItemNotFound": "Dictionary item not found",
      "discountAmount": "Discount Amount",
      "discountRate": "Discount Rate (%)",
      "displayBasePrice": "Display Base Price",
      "displaySavedPercent": "Display Saved %",
      "editMachine": "Edit Machine",
      "editMachineFavoriteFailed": "Failed to edit machine favorite",
      "editMachineFavoriteSuccess": "Machine favorite updated successfully",
      "editMachineProtocolConfigFailed": "Failed to update machine protocol configuration",
      "editMachineProtocolConfigSuccess": "Machine protocol configuration updated successfully",
      "editMachineTransferLogFailed": "Failed to update machine transfer log",
      "editMachineTransferLogSuccess": "Machine transfer log updated successfully",
      "editProtocolConfig": "Machine Configuration",
      "email": "Email",
      "enableTimeout": "Enable Timeout Settings",
      "enterChoosePaymethodTitle": "Please enter payment method text",
      "enterChoosePlanText": "Please enter choose plan text",
      "enterChooseProgramTitle": "Please enter choose program title",
      "enterDeviceSn": "Please enter Device SN",
      "enterDeviceSnOrQrCode": "Please enter Device SN or QR Code",
      "enterOrgNo": "Please enter organization number",
      "enterQrCodeNo": "Please enter QR Code",
      "enterResultDescription": "Please enter result page description",
      "enterResultTitle": "Please enter result page title",
      "enterSinglePriceGoodsNameText": "Please enter Single Price \"Total\" Text",
      "enterSinglePriceGoodsUnitText": "Please enter Single Price additional text",
      "enterTransferRemark": "Enter transfer remark",
      "errorMessage": "Error Message",
      "favoriteFailed": "Failed to favorite",
      "favoriteMachines": "Favorite Machines",
      "favoriteRecordNotFound": "Favorite record not found",
      "favoriteSuccess": "Favorite successfully",
      "fixedAmount": "Fixed Amount",
      "fixedRateNotNegative": "Fixed rate cannot be negative",
      "freeVend": "Remote Vend",
      "freeVendTooltip": "Dispense an item remotely without charging the user",
      "fromOrg": "From Organization",
      "generateQrCodeImageFailed": "Failed to generate QR code image",
      "generateQrCodeLinkFailed": "Failed to generate QR code link",
      "gift": "Gift",
      "goLive": "Go Live",
      "goodsImage": "Product Image",
      "help": {
        "addCurrencySymbol": "Whether to add currency symbol in price display",
        "animationDuration": "Animation duration, range 1-10 seconds, controls the duration of animation playback",
        "belongingOrg": "Select the organization the machine belongs to, cannot be modified after creation",
        "choosePaymethodTitle": "Choose paymethod title, text displayed as the title in the paymethod selection area",
        "choosePlanText": "Choose plan text, used for display on terminal devices",
        "providerName": "Terminal payment provider (BrePay / MercadoPago), pushed in base config as provider.name",
        "chooseProgramTitle": "Choose program title, text displayed as the title in the price selection area",
        "city": "City where the machine is located",
        "cashProduct": "Cash order product name. Stored only in machine protocol config and not pushed to device",
        "coinCount": "Pulse aggregation,range 1-999, how many pulses are considered 1 Play/ 1 Trasaction(E.g. if 1 Play is 6 Pulses X0.25$, then the setting should be 6, and 0.25 in the Coin Value Parameter)",
        "coinValue": "Equals to the smallest coin/bill, for example 0.25$ in your own currency",
        "country": "Country where the machine is located",
        "detailedLocation": "Detailed address information of the machine",
        "detectionMethod": "Detection method, none means no detection, pulse means detection through pulse signal",
        "deviceSn": "Device serial number, used to identify and assign physical devices",
        "enableTimeout": "Whether to enable timeout settings, when enabled can configure timeout duration and detection method",
        "gift": "Gift quantity, range 0-999, represents the number of gifts provided at this price",
        "indexGoodsImg": "Index goods image, displayed as the image in the index goods area",
        "locationInfo": "Location information of the machine, including country, city and detailed address",
        "machineImage": "Upload the main image of the machine, supports jpg/png format, size not exceeding 1MB",
        "machineName": "Display name of the machine, used to identify the machine in the system, length 2-50 characters",
        "machineNumber": "Unique number of the machine, used to identify the machine, cannot be modified after creation",
        "machineTags": "Add tags to the machine for categorization and filtering, supports creating new tags",
        "machineType": "Select the type of machine, different types have different business rules and functions",
        "orgNo": "Please enter the organization number of the target organization",
        "orgPaymentPackage": "Select the organization payment preset, which determines the available payment channels and methods for the machine",
        "preAnimationGifs": "Pre-animation GIFs, displayed as the pre-animation GIFs in the payment success page",
        "preAnimationStaticImg": "Pre-animation static image, displayed as the pre-animation static image in the payment success page",
        "priceMode": "Price mode, discount for automatic discount calculation, gift for manual gift quantity input",
        "priceText": "Price text, custom text displayed in the price selection area",
        "priceYuan": "Price ≥0, supports up to 2 decimal places; if a payment preset is assigned the price must also meet the preset conditions min: {min}/ max: {max}",
        "protocolCode": "Select protocol type, different protocols have different configuration options and functions",
        "pulseActive": "Pulse active duration, in milliseconds, default 100ms",
        "pulseActiveTime": "Pulse active time, range 1-9999 milliseconds, controls the duration of pulse signal",
        "pulseCount": "Pulse count, range 1-9999, must be a multiple of coin count",
        "pulseInactive": "Pulse inactive duration, in milliseconds, default 100ms",
        "pulseInactiveTime": "Pulse inactive time, range 1-9999 milliseconds, controls the interval between pulse signals",
        "pulseUnit": "How many pulses to report at once, default 1",
        "qrCodeNo": "QR number, used to assign payment QR code to the machine",
        "quantity": "Quantiy Text, range 1-999, represents text before the Plays, Games, Minutes - E.g 5(Plays), 2 (Minutes)",
        "remark": "Remarks for the machine, used to record additional notes or comments",
        "resultAnimationGifs": "Result animation GIFs, displayed as the result animation GIFs in the payment success page",
        "resultAnimationStaticImg": "Result animation static image, displayed as the result animation static image in the payment success page",
        "resultDescription": "Result description, displayed as the description in the payment success page",
        "resultTitle": "Result title, displayed as the title in the payment success page",
        "sceneType": "Select application type, different scenes have different display options and functions",
        "selectProduct": "Select the product for free vend, choose from configured pulse protocol prices",
        "serviceFeeRate": "Convenience Fee rate, percentage type range 0-100, fixed amount type range ≥0",
        "serviceFeeType": "Select Convenience Fee type, percentage calculates as a percentage of transaction amount, fixed amount is a fixed fee per transaction",
        "showInsertedCoin": "Whether to display the count of inserted coins",
        "singlePriceGoodsNameText": "Overide the default \"Total\" with your own text",
        "singlePriceGoodsUnitText": "Add additional text under the single price amount.",
        "status": "Select machine status, disabled machines will not be able to perform payment operations",
        "supportOnlinePayment": "After enabling, the machine will support online payment functionality",
        "taxRate": "Tax rate, range 0-100%, calculated as a percentage",
        "theme": "Select the terminal theme style used to control the visual appearance of the payment page",
        "timeoutDuration": "Timeout duration, range 1-300 seconds, exceeding this duration will trigger timeout handling",
        "timeoutNonCash": "Whether to allow non-cash transactions after delivery timeout",
        "toOrg": "Select target organization, the machine will be transferred to this organization",
        "transferMode": "Select the method to transfer the machine",
        "transferReason": "Transfer reason, explains the reason for machine transfer, maximum 200 characters"
      },
      "imageSizeLimit": "Image size cannot exceed 1MB",
      "imageUploadFailed": "Failed to upload image",
      "imageUploadSuccess": "Image uploaded successfully",
      "imageUploadTip": "Only jpg/png files allowed, max 1MB",
      "inactiveTime": "Inactive Time(ms)",
      "indexGoodsImg": "Index Goods Image",
      "indexGoodsImgSettings": "Index Goods Image Settings",
      "invalidProduct": "Selected product is invalid",
      "isBindDevice": "Assigned Device",
      "isBindQr": "Assigned QR",
      "isGoodsCollapsible": "Add more prices in hidden mode",
      "jvma": "JVMA",
      "jvmaProtocol": "JVMA Protocol",
      "loadAccessLogFailed": "Failed to load access log",
      "loadCashLogFailed": "Failed to load cash clear log",
      "loadDeviceTagsFailed": "Failed to load device tags",
      "loadDeviceTypesFailed": "Failed to load device types",
      "loadFavoriteMachinesFailed": "Failed to load favorite machines",
      "loadingOrgDeviceTree": "Loading galaxy & machine tree...",
      "machines": "Machines",
      "loadMachineDetailFailed": "Failed to load machine detail",
      "loadOrgPayPackageFailed": "Failed to load organization payment preset",
      "loadTransferFailed": "Failed to load transfer records",
      "loadTransferLogListFailed": "Failed to load transfer log list",
      "location": "Location",
      "locationInfo": "Location Information",
      "longitudeLatitude": "Longitude & Latitude",
      "lottieAssetsUploadComplete": "Lottie animation assets upload complete",
      "lottieAssetsUploadTip": "External image resources detected in Lottie animation, please upload the corresponding image files in order",
      "lottieHasExternalAssets": "External image resources detected in Lottie animation, it is recommended to use Lottie files with Base64 inline images",
      "machineBinding": "Machine Assignment",
      "machineConfigExistsPrompt": "A machine configuration (machine.cfg) already exists for this device. Update the existing configuration?",
      "machineConfigUpdateSuccess": "Machine configuration updated",
      "machineImage": "Machine Picture(For internal use only)",
      "machineInfo": "Machine Info",
      "machineName": "Machine Name",
      "machineNumber": "Machine Number",
      "machineTags": "Machine Tags",
      "machineTransferLog": "Machine Transfer Log",
      "machineType": "Machine Type",
      "mapSelectorPending": "Map selector feature is pending implementation",
      "mdb": "MDB",
      "mdbProtocol": "MDB Protocol",
      "missingQrCodeInfo": "Missing QR code information",
      "modeLabel": "Mode:",
      "modeSwitchFailed": "Mode switch failed",
      "newOrgMachineNo": "New Org Machine No.",
      "next": "Next",
      "noBindDevice": "This machine has no assigned device",
      "noErrorMessage": "No Error Message",
      "noFavorites": "No favorites",
      "noImage": "No Image",
      "noPermissionAddMachine": "No permission to add machine",
      "noPermissionAddMachineFavorite": "No permission to add machine favorite",
      "noPermissionDeleteMachine": "No permission to delete machine",
      "noPermissionEditMachineFavorite": "No permission to edit machine favorite",
      "noPermissionQueryMachineDetail": "No permission to query machine detail",
      "noPermissionQueryMachineList": "No permission to query machine list",
      "noPermissionQueryOrgTree": "No permission to query organization tree",
      "noPermissionUpdateMachine": "No permission to update machine",
      "noPreviewImage": "No Preview Image",
      "noProtocolConfig": "No protocol configured, click the Add Protocol button above to start configuration",
      "noPulseProtocolConfig": "PULSE protocol configuration not found or product configuration is empty, please configure protocol first",
      "noQrCodeLink": "No link to copy",
      "noTransferLog": "No transfer records",
      "noTransferOrg": "No available organizations. Please create one first.",
      "notSet": "Not Set",
      "offline": "Offline",
      "oldOrgMachineNo": "Old Org Machine No.",
      "online": "Online",
      "onlineStatus": "Online Status",
      "onlyImageFiles": "Only image files allowed",
      "onlyImageOrJsonFiles": "Only image files or Lottie animation JSON files are allowed",
      "operateTime": "Operate Time",
      "operationFailed": "Operation failed, please check form data",
      "operator": "Operator",
      "orgChange": "Organization Change",
      "orgDeviceNumber": "Current Org Machine ID",
      "orgDeviceTree": "System Machine Tree",
      "orgMachineNoChange": "Org Machine No. Change",
      "orgName": "Organization Name",
      "orgNo": "Organization Number",
      "orgPaymentPackage": "Payment Preset",
      "orgType": "Organization Type",
      "outputSignalSentSuccess": "Output signal sent successfully",
      "pause": "Pause",
      "paymentPreAnimation": "Payment Pre-animation",
      "paymentResultAnimation": "Payment Result Animation",
      "pending": "Pending",
      "percentage": "Percentage",
      "percentageRateRange": "Percentage must be between 0-100",
      "play": "Play",
      "pleaseConfigurePaymentPackage": "Please configure payment package first",
      "machinePriceConfigInvalid": "Machine configuration cannot be saved. Please check if the prices are within the payment preset range",
      "priceOutOfPackageRange": "Price acceeds the payment preset range (Min: {min}  Max: {max})",
      "pricePackageRangePlaceholder": "Package range: {min} ~ {max}",
      "pleaseSelectDevice": "Please select a machine first",
      "pleaseSelectProduct": "Please select a product",
      "pleaseUploadAllAssets": "Please upload all assets before confirming",
      "preAnimationGifs": "Pre-animation GIFs",
      "preAnimationStaticImg": "Pre-animation Static Image",
      "preview": "Preview",
      "previewActiveTime": "Active Time",
      "previewCashHandling": "Cash Handling",
      "previewChoosePlanText": "Choose Plan Text",
      "previewChooseProgramTitle": "Choose Program Title",
      "previewCashProduct": "Product",
      "previewCoinCount": "Coin Count",
      "previewCoinValue": "Coin Value",
      "previewCurrencySymbol": "Currency Symbol",
      "previewDetectionMethod": "Detection Method",
      "previewDiscount": "discount",
      "previewDiscountAmount": "Discount Amount",
      "previewEnableTimeout": "Enable Timeout",
      "previewInactiveTime": "Inactive Time",
      "previewNo": "No",
      "previewPriceItem": "Price",
      "previewPriceMode": "Price Mode",
      "previewPriceSettings": "Price Settings",
      "previewPulse": "pulse",
      "previewTax": "Tax Rate",
      "previewTextSettings": "Text Settings",
      "previewTimeoutDuration": "Timeout Duration",
      "previewTimeoutNonCash": "Timeout Non-Cash",
      "previewTitle": "Pulse Protocol Configuration",
      "previewUnit": "pcs",
      "previewYes": "Yes",
      "previous": "Previous",
      "priceDiscount": "Price Discount",
      "priceMode": "Price Mode",
      "priceModeDiscount": "Price Discount Mode",
      "priceModeGift": "Bonus Games Mode",
      "priceNumber": "Price",
      "priceSettings": "Price Settings",
      "priceText": "Price Text",
      "priceYuan": "Price",
      "prices": " prices",
      "prodMode": "Production",
      "prodModeWarn": "In Production Mode now",
      "productOptionLabel": "Price: {price} | Pulse Count: {pulseCount}",
      "productionSubtext": "Live transactions enabled",
      "protocolCode": "Protocol Type",
      "protocolConfig": "Protocol Configuration",
      "protocolCreateSuccess": "Protocol created successfully",
      "protocolName": "Protocol Name",
      "protocolUpdateSuccess": "Protocol updated successfully",
      "inhibit": "Inhibit",
      "inhibitMode": "Inhibit Mode",
      "inhibitModeHint": "Active, the Trilad device will be inhibited by the machine controller according to the below logic.",
      "inhibitEnabled": "Enabled",
      "inhibitDisabled": "Disabled",
      "signalPolarity": "Signal Polarity",
      "signalPolarityHint": "The machine controller will output {polarity} level to inhibit the Trilad Payment device.",
      "activeHigh": "Active High",
      "activeLow": "Active Low",
      "pulse": "Pulse",
      "pulseActive": "Pulse Active Duration",
      "pulseConfig": "Pulse Configuration",
      "pulseCount": "Number of Pulses",
      "pulseCountMustBeMultipleOfCoinCount": "Pulse count must be a multiple of coin count ({coinCount})",
      "pulseDevice": "Pulse Device",
      "pulseInactive": "Pulse Inactive Duration",
      "pulseProtocol": "Pulse Protocol",
      "pulseProtocolConfig": "Pulse Protocol Configuration",
      "pulsePriceRequired": "At least one price in the price list must be greater than 0 before saving a Pulse protocol",
      "mdbCurrencyNumericCodeRequired": "Before saving an MDB protocol, the machine must have a payment package currency numeric code configured",
      "pulseSettings": "Pulse Settings",
      "pulseUnit": "Pulse Report Unit",
      "qrCode": "QR Code",
      "qrCodeDialogTitle": "QR Code Information",
      "qrCodeGenerating": "Generating QR code...",
      "qrCodeImage": "QR Code",
      "qrCodeLink": "Link",
      "qrCodeNo": "QR Number",
      "qrId": "QR ID",
      "quantity": "Quantity",
      "queryMachineDetailFailed": "Failed to query machine detail",
      "queryMachineFavoriteListFailed": "Failed to query machine favorite list",
      "queryMachineListFailed": "Failed to query machine list",
      "queryMachineProtocolConfigFailed": "Failed to query machine protocol configuration",
      "queryMachineTagsFailed": "Failed to query machine tags",
      "queryMachineTransferLogListFailed": "Failed to query machine transfer log list",
      "queryMachineTypeFailed": "Failed to query machine type",
      "queryOrgPayPackageFailed": "Failed to query organization payment preset",
      "queryOrgTreeFailed": "Failed to query organization tree",
      "refreshMachineDetailFailed": "Failed to refresh machine detail",
      "refreshMachineDetailSuccess": "Machine detail refreshed successfully",
      "refreshOrgDeviceListFailed": "Failed to refresh organization device list",
      "remark": "Remark",
      "removeFavoriteFailed": "Failed to remove from favorites",
      "removeFavoriteSuccess": "Removed from favorites successfully",
      "resultAnimationGifs": "Result Animation GIFs",
      "resultAnimationStaticImg": "Result Animation Static Image",
      "resultDescription": "Result Page Description",
      "resultTitle": "Result Page Title",
      "sandboxMode": "Demo",
      "sandboxModeWarn": "In Demo Mode now",
      "sandboxSubtext": "Simulated transactions only",
      "save": "Save",
      "saveQrCode": "Save QR Code",
      "saveQrCodeFailed": "Save failed",
      "saveQrCodeSuccess": "Save successful",
      "saveText": "Save Text",
      "sceneType": "Application Type",
      "sceneTypeH5": "H5",
      "sceneTypeTerminal": "Terminal",
      "searchOrgOrDevice": "Search organizations or machines...",
      "searchMachines": "Search machines...",
      "foundMachines": "Found {count} machines",
      "orgScope": {
        "search": "Search Galaxy...",
        "select": "Select",
        "empty": "No organizations found",
        "saveFailed": "Failed to save organization scope"
      },
      "treePopover": {
        "machineType": "Machine Type",
        "machineNumber": "Machine No.",
        "device": "Device",
        "notAssigned": "Not Assigned",
        "qr": "QR",
        "number": "No.",
        "url": "URL",
        "checkoutPage": "Checkout Page",
        "lastOnline": "Last Online"
      },
      "searching": "Searching for organizations or machines containing \"{keyword}\"",
      "selectImage": "Select Image",
      "selectImageRequired": "Please select machine image",
      "selectLocation": "Select Location",
      "selectOrgOrDevice": "Please select a device from the left to view details",
      "selectProduct": "Select Product",
      "selectProductPlaceholder": "Please select a product",
      "selectTargetOrg": "Please select a target organization",
      "sendOutputSignalFailed": "Failed to send output signal, please try again later",
      "serviceFeeRate": "Convenience Fee (Extra Charge)",
      "serviceFeeType": "Convenience Fee Type",
      "shenzhen": "Shenzhen",
      "shenzhenIndustrialPark": "Shenzhen Baoan Industrial Park",
      "showInsertedCoinCount": "Show Inserted Coin Count",
      "singlePriceGoodsNameText": "Single Price \"Total\" Text",
      "singlePriceGoodsUnitText": "Single Price additional text",
      "stateLabel": "State:",
      "supportOnlinePayment": "Support Online Payment",
      "switchToSandbox": "Switch to Demo",
      "sysMachineNo": "System Machine No.",
      "systemDeviceNumber": "System Machine ID",
      "taxRate": "Tax Rate (%)",
      "taxSettings": "Tax Settings",
      "protocolConfigTitle": "{protocol} Configuration",
      "mdbCurrencyScaling": "Currency Scaling",
      "mdbExample": "e.g.",
      "mdbScaleFactor": "Scale Factor",
      "mdbDecimalPlace": "Decimal Place",
      "mdbProtocolLevel": "MDB Protocol Level",
      "mdbLevelOption": "Level {level}",
      "mdbLevelHintEnabled": "Level 3 enables Always Idle Mode. When changing this parameter the device will reset",
      "mdbLevelHintConnected": "The connected machine is using MDB Level 2",
      "mdbLevelHintDisabled": "Always Idle Mode is not supported on MDB Level {level}",
      "mdbAlwaysIdleMode": "Always Idle Mode",
      "mdbAlwaysIdleHintEnabled": "The transaction will start by choosing a product on the vending machine",
      "mdbAlwaysIdleHintDisabled": "The transaction will start by touching the terminal to provide a default credit to the vending machine",
      "mdbAlwaysIdleHintUnavailable": "Disabled because Always Idle requires MDB Level 3 or higher",
      "mdbCreditLimit": "Default Credit",
      "mdbDefaultCredit": "Default Credit",
      "mdbUseHighestLimit": "Use Highest Limit",
      "mdbMonetaryFormat": "Monetary Format",
      "mdbMonetaryFormat16Hint": "Standard monetary format for compatible machine controllers.",
      "mdbMonetaryFormat32Hint": "Extended monetary range for high-value transactions, when supported by the machine controller.",
      "mdbCreditLimitAdjusted": "Switched to {format}. Default Credit has been adjusted to the maximum allowed value of {value}.",
      "mdbCreditLimitHint": "Maximum allowed value is {value} ({maxInteger} × Scale Factor / (10^Decimal Place))",
      "mdbAutoRefund": "Auto Refund",
      "mdbAutoRefundHint": "Automatically refund the customer if payment succeeds but the machine reports a failed vend",
      "mdbVendResultTimeout": "Vend Result Timeout",
      "mdbVendResultTimeoutHint": "Maximum 1800 seconds",
      "mdbCashSale": "Cash Sale",
      "mdbCashSaleHint": "Allowing the VMC to report Cash transaction to the Trilad device",
      "mdbSessionIdleTimeout": "Session Idle Timeout",
      "mdbMaximum255Seconds": "Maximum 255 seconds",
      "mdbApplicationMaximumResponseTime": "Application Maximum Response Time",
      "textSettings": "Text Settings",
      "theme": "Theme",
      "themeZorbamaticGemstone": "Zorbamatic Gemstone",
      "themeZorbamaticWoodenBalls": "Zorbamatic Wooden Balls",
      "themeDarkFlame": "Dark Flame",
      "themeDefault": "Default Theme",
      "themePeppaPigKiddleRide": "Peppa Pig Kiddle Ride",
      "themeGashapon": "Gashapon",
      "themeArcade": "Arcade",
      "themePennyPress": "PennyPress",
      "themePinball": "Pinball",
      "themeMassageChair": "MassageChair",
      "timeoutDuration": "Timeout Duration",
      "timeoutNonCash": "Allow non-cash transactions after timeout",
      "timeoutSettings": "Timeout Settings",
      "title": "Machine Management",
      "toOrg": "To Organization",
      "totalFrames": "Total Frames",
      "transferFailed": "Machine transfer failed",
      "transferMode": "Transfer Mode",
      "transferModeOrgNo": "Enter Org Number",
      "transferModeTree": "Select from Org Tree",
      "transferOrgSameWarning": "Target organization cannot be the same as the current one",
      "transferReason": "Transfer Reason",
      "transferResult": "Transfer Result",
      "transferStatus": "Transfer Status",
      "transferSuccess": "Machine transfer succeeded",
      "triladSerial": "Trilad Serial",
      "triladSerialProtocol": "Trilad Serial Protocol",
      "unbindDevice": "Unassign Device",
      "unbindDeviceFailed": "Failed to unassign device",
      "unbindDeviceSuccess": "Device successfully unassigned",
      "unbound": "Not Assigned",
      "unitPrice": "Unit Price",
      "unitSecond": "Second(s)",
      "unknownDevice": "Unknown Device",
      "unsupportedPlatProductCode": "Unsupported platform product code",
      "updateMachineFailed": "Failed to update machine",
      "updateMachineSuccess": "Machine updated successfully",
      "uploadGif": "Upload GIF",
      "uploadGifTip": "Support GIF format, single image less than 1MB",
      "uploadImage": "Upload Image",
      "uploadImageTip": "Support JPG, PNG, GIF formats, single image less than 1MB",
      "uploadLottieAssets": "Upload Lottie Animation Assets",
      "uploaded": "Uploaded",
      "viewAccessLog": "View Log",
      "viewQrCode": "View QR Code",
      "viewTransactions": "View Transactions"
    }
  },
  "report": {
    "authorizationOrder": {
      "dialog": {
        "authInfo": "Authorization Information",
        "basicInfo": "Basic Information",
        "captureAmount": "Capture Amount",
        "captureInfo": "Capture Txn",
        "captureOrderNo": "Capture Txn No.",
        "captureStatus": "Capture Status",
        "captureTime": "Capture Time",
        "channelErrorCode": "Channel Error Code",
        "channelErrorMsg": "Channel Error Message",
        "channelResponseTime": "Channel Response Time",
        "goodsAmount": "Goods Amount",
        "noCaptureOrder": "No capture transaction",
        "noVoidOrder": "No void transaction",
        "orgPayFee": "Organization Payment Fee",
        "outputNums": "Output Quantity",
        "outputStatus": "Output Status",
        "payResponseTime": "Payment Response Time",
        "payToken": "Payment Token",
        "remark": "Remark",
        "serviceFee": "Convenience Fee",
        "settleTime": "Settlement Time",
        "taxFee": "Tax Fee",
        "thirdDes": "Third Party Description",
        "thirdResponseTime": "Third Party Response Time",
        "title": "Authorization Txn Details",
        "traceId": "API Request No.",
        "voidAmount": "Void Amount",
        "voidInfo": "Void Txn",
        "voidOrderNo": "Void Txn No.",
        "voidStatus": "Void Status",
        "voidTime": "Void Time"
      },
      "messages": {
        "loadCaptureFailed": "Failed to load capture transaction",
        "loadDataFailed": "Failed to load authorization transaction data",
        "loadDetailFailed": "Failed to load authorization transaction details",
        "loadVoidFailed": "Failed to load void transaction"
      },
      "searchForm": {
        "channelAuthOrderNo": "Channel Auth Txn No.",
        "dateRange": "Date Range",
        "deviceNumbers": "Device Numbers",
        "endPlaceholder": "End Date",
        "keyword": "Keyword Search",
        "machineNumbers": "Machine Numbers",
        "merchantAuthOrderNo": "Merchant Auth Txn No.",
        "orderStatus": "Txn Status",
        "placeholder": {
          "deviceNumbers": "Please select Device numbers",
          "keyword": "Please enter transaction number, device number, etc.",
          "machineNumbers": "Please select Machine numbers"
        },
        "platformAuthOrderNo": "Platform Auth Txn No.",
        "rangeSeparator": "To",
        "startPlaceholder": "Start Date"
      },
      "status": {
        "FAILED": "Failed",
        "Processing": "Processing",
        "SUCCEEDED": "Succeeded",
        "UNATTEMPTED": "Unattempted",
        "closed": "Closed",
        "opened": "Opened",
        "pending": "Pending",
        "processing": "Processing",
        "shipped": "Shipped",
        "shippedFail": "Shipment Failed",
        "unShipped": "Unshipped"
      },
      "table": {
        "authAmount": "Authorization Amount",
        "authStatus": "Authorization Status",
        "captureAmount": "Capture Amount",
        "captureStatus": "Capture Status",
        "channelAuthOrderNo": "Channel Auth Txn No.",
        "createTime": "Create Time",
        "currency": "Currency",
        "deviceId": "Device ID",
        "deviceName": "Device Name",
        "deviceSn": "Device SN",
        "doorStatus": "Door Status",
        "merchantAuthOrderNo": "Merchant Auth Txn No.",
        "operation": "Operation",
        "orgMachineNo": "Org Machine No.",
        "payChannel": "Payment Channel",
        "payMethod": "Payment Method",
        "platformAuthOrderNo": "Platform Auth Txn No.",
        "thirdStatus": "Third Party Status",
        "updateTime": "Update Time",
        "viewDetail": "View Details",
        "voidStatus": "Void Status"
      },
      "thirdStatus": {
        "00": "Success",
        "01": "Failed"
      },
      "title": "Authorization Transactions"
    },
    "transactions": {
      "title": "Transactions",
      "export": "Export",
      "exportProgress": {
        "title": "Export",
        "exporting": "Exporting...",
        "count": "Fetched {fetched} / {total}"
      },
      "exportHeaders": {
        "txnId": "TXN ID",
        "machineName": "Machine Name",
        "machineNumber": "Machine Number",
        "deviceType": "Device Type",
        "deviceNo": "Device No",
        "type": "Type",
        "status": "Status",
        "selectionProducts": "Selection/Products",
        "currency": "Currency",
        "orderAmount": "Order Amount",
        "authAmount": "Auth Amount",
        "settledAmount": "Settled Amount",
        "createdTime": "Created Time",
        "settlementTime": "Settlement Time",
        "authTime": "Auth Time",
        "paymentChannel": "Payment Channel",
        "paymentProvider": "Payment Provider",
        "paymentMethod": "Payment Method",
        "galaxyName": "Galaxy Name",
        "galaxyId": "Galaxy ID"
      },
      "liveMode": "Live Mode",
      "demoMode": "Demo Mode",
      "search": {
        "dateRange": "Date Range",
        "createdTime": "Created Time",
        "authTime": "Auth Time",
        "settlementTime": "Settlement Time",
        "to": "To",
        "startTime": "Start Time",
        "endTime": "End Time",
        "txnId": "Txn ID",
        "txnIdPlaceholder": "TXN ID",
        "machineDevice": "Machine/Device",
        "machineDevicePlaceholder": "Name/No./SN/QR",
        "galaxy": "Galaxy",
        "galaxyPlaceholder": "Please select",
        "type": "Txn Type",
        "status": "Status",
        "payment": "Payment",
        "method": "Method",
        "channel": "Channel",
        "provider": "Provider"
      },
      "table": {
        "displayOrderNo": "Txn ID",
        "machineDevice": "Machine/Device",
        "galaxyId": "Galaxy/ID",
        "machineNo": "Machine No.",
        "deviceSn": "Device SN",
        "methodChannel": "Method/Channel",
        "typeStatus": "Type/Status",
        "selectionProducts": "Selection/Products",
        "orderAmount": "Order Amount",
        "authAmount": "Auth Amount",
        "settledAmount": "Settled Amount",
        "authTime": "Auth Time",
        "settlementTime": "Settlement Time",
        "paymentChannel": "Payment Channel",
        "paymentProvider": "Payment Provider",
        "paymentMethod": "Payment Method",
        "createdTime": "Created Time",
        "operation": "Operation",
        "clickToCopy": "Click to copy",
        "machineConfiguration": "Machine Configuration"
      },
      "type": {
        "sale": "Sale",
        "freeVend": "Free Vend",
        "preAuth": "Pre-Auth",
        "cash": "Cash",
        "refund": "Refund"
      },
      "status": {
        "pending": "Pending",
        "processing": "Processing",
        "refundProcessing": "Refund Processing",
        "success": "Success",
        "failed": "Failed",
        "refundFailed": "Refund Failed",
        "authFailed": "Auth Failed",
        "cancelled": "Cancelled",
        "authorized": "Authorized",
        "notComplete": "Not Complete",
        "voided": "Voided",
        "refundReview": "Refund Review",
        "refundRejected": "Refund Rejected",
        "fullyRefunded": "Fully Refunded",
        "partiallyRefunded": "Partially Refunded"
      },
      "detail": {
        "currentTimezone": "Display",
        "machineTimezone": "Machine",
        "tabs": {
          "payment": "Payment",
          "refund": "Refund",
          "order": "Order",
          "fees": "Fees",
          "machine": "Machine"
        },
        "machineInfo": "Machine Info",
        "type": "Type",
        "currency": "Currency",
        "status": "Status",
        "fee": "Fee",
        "netAmount": "Net Amount",
        "authorized": "Authorized",
        "order": "Order",
        "settled": "Settled",
        "vend": "Vend",
        "vendStatus": {
          "success": "Success",
          "processing": "Processing",
          "failed": "Failed"
        },
        "machineName": "Machine Name",
        "machineNo": "Machine No.",
        "systemMachineNo": "System Machine No.",
        "deviceNo": "Device SN",
        "qrNo": "QR No.",
        "location": "Location",
        "operatorName": "Operator Name",
        "operatorId": "Operator ID",
        "paymentMethod": "Payment Method",
        "paymentChannel": "Payment Channel",
        "paymentProvider": "Payment Provider",
        "providerTxnId": "Provider Txn ID",
        "payerName": "Payer Name",
        "createdTime": "Created Time",
        "authTime": "Auth Time",
        "settlementTime": "Settlement Time",
        "refundOrder": "Refund Order",
        "refundApplications": "Refund Applications",
        "id": "ID",
        "refundTime": "Refund Time",
        "applicant": "Applicant",
        "applicationTime": "Application Time",
        "auditComment": "Audit Comment",
        "description": "Description",
        "units": "Units",
        "price": "Price",
        "amount": "Amount",
        "bill": "Bill",
        "coin": "Coin",
        "totalAmount": "Total Amount",
        "subtotal": "Subtotal",
        "discount": "Discount",
        "tax": "Tax",
        "convenienceFee": "Convenience Fee",
        "handlingFee": "Processing Fee",
        "transactionTax": "VAT on Processing Fees"
      },
      "messages": {
        "loadDataFailed": "Failed to load transactions",
        "noExportData": "No data available for export"
      }
    },
    "refundApply": {
      "auditDialog": {
        "auditComment": "Audit Comment",
        "auditResult": "Audit Result",
        "confirmMessage": "Are you sure you want to {result} this refund application?",
        "confirmTitle": "Confirm Audit",
        "placeholder": {
          "auditComment": "Please enter audit comment (required for rejection)"
        },
        "title": "Audit Refund Application",
        "validation": {
          "auditCommentLength": "Audit comment cannot exceed 500 characters",
          "auditCommentRequiredForReject": "Audit comment is required when rejecting",
          "auditResultRequired": "Please select audit result"
        }
      },
      "auditResult": {
        "APPROVED": "Approve",
        "REJECTED": "Reject"
      },
      "dateRange": {
        "endPlaceholder": "End Date",
        "separator": "to",
        "startPlaceholder": "Start Date"
      },
      "dialog": {
        "applyInfo": "Application Information",
        "title": "Application Detail"
      },
      "messages": {
        "auditFailed": "Audit failed",
        "auditSuccess": "Audit successful",
        "loadDataFailed": "Failed to load refund application data",
        "loadDetailFailed": "Failed to load application detail"
      },
      "searchForm": {
        "applyNo": "Application No.",
        "applyStatus": "Application Status",
        "dateRange": "Application Time",
        "orderNo": "Order No."
      },
      "status": {
        "APPROVED": "Approved",
        "CANCELLED": "Cancelled",
        "PENDING": "Pending",
        "REJECTED": "Rejected",
        "REFUND_PROCESSING": "Refund Processing",
        "REFUND_SUCCEEDED": "Refund Succeeded",
        "REFUND_FAILED": "Refund Failed"
      },
      "table": {
        "applicantName": "Applicant",
        "applyAmount": "Application Amount",
        "applyNo": "Application No.",
        "applyReason": "Application Reason",
        "applyStatus": "Application Status",
        "applyTime": "Application Time",
        "audit": "Audit",
        "auditComment": "Audit Comment",
        "auditTime": "Audit Time",
        "auditorName": "Auditor",
        "currency": "Currency",
        "operation": "Operation",
        "orderNo": "Order No.",
        "refundOrderNo": "Refund Order No.",
        "viewDetail": "View Detail"
      },
      "title": "Refund Application Management"
    },
    "salesAnalysis": {
      "salesDescription": "Sales analysis feature is under development, please stay tuned...",
      "salesDeveloping": "Feature in Development",
      "title": "Sales by"
    },
    "salesByMachine": {
      "title": "Sales By Machine",
      "exportProgress": {
        "title": "Export Excel",
        "exporting": "Exporting...",
        "count": "Fetched {fetched} / {total}"
      },
      "exportHeaders": {
        "machineName": "Machine Name",
        "machineNumber": "Machine Number",
        "deviceType": "Device Type",
        "deviceNo": "Device No",
        "galaxyName": "Galaxy Name",
        "galaxyCurrency": "Galaxy Currency",
        "totalsTxns": "Totals Txns",
        "totalsGrossAmt": "Totals Gross Amt",
        "totalsCashlessCashPct": "Totals Cashless/Cash $%",
        "cashlessTxns": "Cashless Txns",
        "cashlessGrossAmt": "Cashless Gross Amt",
        "cashlessAtv": "Cashless ATV",
        "cashTxns": "Cash Txns",
        "cashAmount": "Cash Amount",
        "cashAtv": "Cash ATV",
        "refundTxns": "Refund Txns",
        "refundAmt": "Refund Amt"
      },
      "overview": {
        "totalMachines": "Total Machines",
        "transactingMachines": "Transacting Machines"
      },
      "search": {
        "galaxy": "Galaxy",
        "galaxyPlaceholder": "Please select",
        "dateRange": "Date Range",
        "to": "To",
        "startTime": "Start Time",
        "endTime": "End Time",
        "reportingCurrency": "Reporting Currency",
        "payment": "Cashless Payment",
        "machineDevice": "Machine / Device",
        "machineDevicePlaceholder": "Name/No./SN/QR"
      },
      "table": {
        "index": "#",
        "machineDevice": "Machine / Device",
        "galaxyCurrency": "Galaxy / Currency",
        "currency": "Currency",
        "totals": "Totals",
        "cashless": "Cashless",
        "cash": "Cash",
        "txns": "Txns",
        "grossAmt": "Gross Amt",
        "cashlessCashPct": "Cashless / Cash $%",
        "atv": "ATV",
        "amount": "Amount",
        "refundTxns": "Refund Txns",
        "refundAmt": "Refund Amt",
        "netAmount": "Net Amount",
        "operation": "Operation"
      },
      "summary": {
        "totalAllResults": "Total - All Results"
      },
      "messages": {
        "noExportData": "No data available for export"
      },
      "columnPreference": {
        "title": "Add/Remove Fields",
        "description": "Select columns to display"
      }
    },
    "transactionOrder": {
      "cashBreakdown": {
        "bill": "Bill",
        "coin": "Coin"
      },
      "dateRange": {
        "endPlaceholder": "End Date",
        "separator": "to",
        "startPlaceholder": "Start Date"
      },
      "dialog": {
        "amountInfo": "Amount Information",
        "applicantName": "Applicant",
        "applyAmount": "Application Amount",
        "applyNo": "Application No.",
        "applyStatus": "Application Status",
        "applyTime": "Application Time",
        "auditComment": "Audit Comment",
        "basicInfo": "Basic Information",
        "channelRefundOrderNo": "Channel Refund Txn No.",
        "commissionServiceFee": "Commission Convenience Fee",
        "currency": "Currency",
        "discountAmount": "Discount Amount",
        "goodsAmount": "Goods Amount",
        "mdrVatAmount": "Transaction Tax",
        "merchantReceivedAmount": "Merchant Received Amount",
        "merchantRefundOrderNo": "Merchant Refund Txn No.",
        "noRefundApplies": "No refund applications",
        "noRefundOrders": "No refund transactions",
        "orgPayFee": "Handling Fee",
        "productExternalId": "Product External ID",
        "productInfo": "Product Information",
        "productInfoLabel": "Product Information",
        "productInternalCode": "Product Internal Code",
        "profit": "Platform Profit",
        "refundAmount": "Refund Amount",
        "refundAmountLabel": "Refund Amount",
        "refundApplies": "Refund Applications",
        "refundOrderNo": "Refund Txn No.",
        "refundOrders": "Refund Transactionss",
        "refundStatus": "Refund Status",
        "refundTime": "Refund Time",
        "serviceFee": "Convenience Fee",
        "singleProductCode": "Single Product Code",
        "title": "Transaction Details"
      },
      "envMode": {
        "production": "Production",
        "sandbox": "Demo"
      },
      "messages": {
        "loadDataFailed": "Failed to load Txn data",
        "loadDetailFailed": "Failed to load Txn details",
        "loadRefundApplyFailed": "Failed to load refund application records",
        "refundAuditNoLongerPending": "This refund request is no longer pending.",
        "loadRefundFailed": "Failed to load refund transactions",
        "refundApplyFailed": "Failed to submit refund application",
        "refundApplyPending": "There is a pending refund application for this order, cannot submit a new one",
        "refundApplySuccess": "Refund application submitted, awaiting review",
        "refundFailed": "Refund failed",
        "refundPending": "This transaction has pending refunds, cannot initiate new refund",
        "refundSuccess": "Refund successful"
      },
      "orderType": {
        "capture": "Pre-authorization Complete",
        "cash_order": "Cash",
        "feeVend": "Free Vend",
        "qr": "Dynamic QR Code",
        "transfer": "Sale",
        "void_order": "Pre-authorization Cancel"
      },
      "prizeWin": {
        "0": "No",
        "1": "Shipped"
      },
      "pulseStatus": {
        "0": "Waiting to Complete",
        "1": "Consuming",
        "2": "Completed"
      },
      "recognitionMethod": {
        "H5": "H5",
        "chip": "Chip Card",
        "magnetic": "Magnetic Card"
      },
      "auditDialog": {
        "amountRequested": "Refund amount requested",
        "auditAction": "Audit refund request",
        "approveMessage": "Are you sure you want to approve refund for this transaction?",
        "approveTitle": "Approve Refund",
        "by": "By",
        "comment": "Comment",
        "placeholder": {
          "approveComment": "Write additional comments here. (Optional)",
          "rejectReason": "Please enter the reason for rejection."
        },
        "refundReason": "Refund Reason",
        "rejectMessage": "Are you sure you want to reject this refund request?",
        "rejectReason": "Reason",
        "rejectTitle": "Reject Refund",
        "requestTime": "Request Time",
        "requestTitle": "Refund Request",
        "requestedBy": "Requested By",
        "validation": {
          "commentLength": "Content cannot exceed 255 characters",
          "rejectReasonRequired": "Please enter the reason for rejection"
        }
      },
      "refundDialog": {
        "applyConfirmMessage": "Are you sure you want to submit a refund application for {amount}?",
        "applyConfirmTitle": "Confirm Submission",
        "applyTitle": "Refund Request",
        "confirmMessage": "Are you sure you want to refund {amount}?",
        "confirmTitle": "Confirm Refund",
        "orderNo": "Txn No.",
        "placeholder": {
          "refundAmount": "Please enter refund amount",
          "refundReason": "Please enter refund reason",
          "withdrawMethodKey": "Please enter user key"
        },
        "refundAmount": "Refund Amount",
        "refundReason": "Refund Reason",
        "refundableAmount": "Max refundable amount",
        "refundedAmount": "Refunded Amount",
        "requestAction": "Request",
        "title": "Refund",
        "totalAmount": "Total Amount",
        "validation": {
          "refundAmountMax": "Refund amount cannot exceed {max}",
          "refundAmountMin": "Refund amount must be greater than 0",
          "refundAmountRequired": "Please enter refund amount",
          "refundReasonLength": "Refund reason length should be between 1 and 500 characters",
          "refundReasonRequired": "Please enter refund reason",
          "withdrawMethodKeyLength": "User key length cannot exceed 200 characters",
          "withdrawMethodKeyRequired": "Please enter user key"
        },
        "withdrawMethodKey": "User Key"
      },
      "searchForm": {
        "channelOrderNo": "Channel Txn No.",
        "dateRange": "Date Range",
        "deviceNumbers": "Device Numbers",
        "keyword": "Keyword Search",
        "machineNo": "Machine No.",
        "machineNumbers": "Machine Numbers",
        "merchantOrderNo": "Merchant Txn No.",
        "orderNo": "Transaction No.",
        "orderStatus": "Transaction Status",
        "orderType": "Transaction Type",
        "placeholder": {
          "deviceNumbers": "Please select Device numbers",
          "keyword": "Please enter transaction number, device number, etc.",
          "machineNo": "Please enter machine number",
          "machineNumbers": "Please select Machine numbers",
          "orderNo": "Please enter transaction number"
        },
        "platformOrderNo": "Platform Txn No."
      },
      "status": {
        "FAILED": "Failed",
        "Processing": "Processing",
        "SUCCEEDED": "Succeeded",
        "UNATTEMPTED": "Unattempted",
        "processing": "Processing",
        "shipped": "Shipped",
        "shippedFail": "Shipment Failed",
        "unShipped": "Unshipped"
      },
      "table": {
        "authDate": "Authorization Date",
        "authTime": "Authorization Time",
        "billAmount": "Bill Amount",
        "channelOrderNo": "Channel Txn No.",
        "coinAmount": "Coin Amount",
        "currency": "Currency",
        "deviceId": "Device ID",
        "deviceName": "Device Name",
        "deviceSn": "Device SN",
        "envMode": "Environment Mode",
        "machineName": "Machine Name",
        "machineNumber": "Machine Number",
        "merchantOrderNo": "Merchant Txn No.",
        "netAmount": "Net Amount",
        "operation": "Operation",
        "orderStatus": "Transaction Status",
        "orderType": "Transaction Type",
        "orgMachineNo": "System Machine No.",
        "outputStatus": "Output Status",
        "payChannel": "Pay Provider",
        "payMethod": "Pay Channel",
        "platformOrderNo": "Platform Txn No.",
        "prizeWin": "Prize Win",
        "productCode": "Product Code",
        "productName": "Product Name",
        "recognitionMethod": "Recognition Method",
        "refund": "Refund",
        "refundAmount": "Refund Amount",
        "refundApply": "Refund",
        "refundStatus": "Refund Status",
        "remark": "Remark",
        "serviceFee": "Convenience Fee",
        "settleDate": "Settlement Date",
        "settleTime": "Settlement Time",
        "taxAmount": "Tax Amount",
        "totalAmount": "Total Amount",
        "viewDetail": "View Details"
      },
      "title": "Transaction Report"
    }
  },
  "routeButton": {
    "auth_getRoleAuth": "Get Role Permissions",
    "button_add": "Add Button",
    "button_delete": "Delete Button",
    "button_findAll": "Query All Buttons",
    "button_getMenuButton": "Query Menu Buttons",
    "button_update": "Edit Button",
    "channelPlatProduct_add": "Add Associated Payment Channel",
    "channelPlatProduct_delete": "Delete Associated Payment Channel",
    "channelPlatProduct_getPage": "Query Associated Payment Channels",
    "channelProduct_add": "Add Channel Product",
    "channelProduct_delete": "Delete Channel Product",
    "channelProduct_getPage": "Query Channel Product List",
    "channelProduct_update": "Edit Channel Product",
    "country_add": "Add Country",
    "country_delete": "Delete Country",
    "country_getPage": "Query Country List",
    "country_update": "Edit Country",
    "currency_add": "Add Currency",
    "currency_delete": "Delete Currency",
    "currency_getPage": "Query Currency List",
    "currency_update": "Edit Currency",
    "dashboard_getCurrencyOptions": "Get Currency Options",
    "dashboard_getMachineLocationList": "Get Machine Location List",
    "dashboard_getMachineOptions": "Get Machine Options",
    "dashboard_getMachinePerformanceBottom": "Get Machine Performance Bottom",
    "dashboard_getMachinePerformanceTop": "Get Machine Performance Top",
    "dashboard_getMachineStatusSummary": "Get Machine Status Summary",
    "dashboard_getMultiPeriodOverview": "Get Multi-Period Overview",
    "dashboard_getPayMethodOptions": "Get Payment Method Options",
    "dashboard_getPaymentMethodBreakdown": "Get Payment Method Breakdown",
    "dashboard_getSalesTrend": "Get Sales Trend",
    "deviceCommandLog_add": "Add Device Command Log",
    "deviceCommandLog_delete": "Delete Device Command Log",
    "deviceCommandLog_getPage": "Query Device Command Log List",
    "deviceCommandLog_update": "Edit Device Command Log",
    "deviceConfigTemplate_add": "Add Device Config Template",
    "deviceConfigTemplate_delete": "Delete Device Config Template",
    "deviceConfigTemplate_getPage": "Query Device Config Template List",
    "deviceConfigTemplate_update": "Edit Device Config Template",
    "deviceConfig_add": "Add Device Config",
    "deviceConfig_delete": "Delete Device Config",
    "deviceConfig_getConfig": "Query Device Configuration",
    "deviceConfig_getPage": "Query Device Config List",
    "deviceConfig_pushConfig": "Push Device Config",
    "deviceConfig_sendCommand": "Send Device Command",
    "deviceConfig_update": "Edit Device Config",
    "deviceModelConfig_add": "Add Device Module Config",
    "deviceModelConfig_delete": "Delete Device Module Config",
    "deviceModelConfig_getPage": "Query Device Module Config List",
    "deviceModelConfig_update": "Edit Device Module Config",
    "deviceType_add": "Add Device Type",
    "deviceType_delete": "Delete Device Type",
    "deviceType_getPage": "Query Device Type List",
    "deviceType_update": "Edit Device Type",
    "device_add": "Add Device",
    "device_advanced_settings": "Device Advanced Settings",
    "device_batchRegister": "Batch Register Devices",
    "device_delete": "Delete Device",
    "device_getDetail": "Query Device Details",
    "device_getDeviceInfo": "Query Device Info",
    "device_getPage": "Query Device List",
    "device_getStatus": "Query Device Status",
    "device_update": "Edit Device",
    "device_bindMachine": "Assign Machine",
    "dictItem_add": "Add Dictionary Item",
    "dictItem_delete": "Delete Dictionary Item",
    "dictItem_getPage": "Query Dictionary Item List",
    "dictItem_update": "Edit Dictionary Item",
    "dict_add": "Add Dictionary",
    "dict_delete": "Delete Dictionary",
    "dict_getPage": "Query Dictionary List",
    "dict_update": "Edit Dictionary",
    "file_upload": "File Upload",
    "machineCashClearLog_getList": "Query Cash Clear Log",
    "machineDeviceRel_getPage": "Query Machine Device Relationship List",
    "machineFavorite_add": "Add Machine Favorite",
    "machineFavorite_delete": "Delete Machine Favorite",
    "machineFavorite_getPage": "Query Machine Favorite List",
    "machineFavorite_update": "Edit Machine Favorite",
    "machineProtocolConfig_add": "Add Machine Protocol Config",
    "machineProtocolConfig_delete": "Delete Machine Protocol Config",
    "machineProtocolConfig_getByMachineId": "Query Machine Protocol Config List By Machine ID",
    "machineProtocolConfig_getPage": "Query Machine Protocol Config List",
    "machineProtocolConfig_update": "Edit Machine Protocol Config",
    "machineTagRel_add": "Add Machine Tag Relation",
    "machineTagRel_delete": "Delete Machine Tag Relation",
    "machineTagRel_getPage": "Query Machine Tag Relation List",
    "machineTagRel_update": "Edit Machine Tag Relation",
    "machineTag_add": "Add Machine Tag",
    "machineTag_delete": "Delete Machine Tag",
    "machineTag_find": "Query Machine Tag",
    "machineTag_getPage": "Query Machine Tag List",
    "machineTag_update": "Edit Machine Tag",
    "machineTransferLog_add": "Add Machine Transfer Log",
    "machineTransferLog_delete": "Delete Machine Transfer Log",
    "machineTransferLog_getPage": "Query Machine Transfer Log List",
    "machineTransferLog_update": "Edit Machine Transfer Log",
    "machineType_add": "Add Machine Type",
    "machineType_delete": "Delete Machine Type",
    "machineType_find": "Query Machine Type",
    "machineType_getPage": "Query Machine Type List",
    "machineType_update": "Edit Machine Type",
    "machine_add": "Add Machine",
    "machine_bind": "Assign Machine",
    "machine_clearCash": "Clear Cash",
    "machine_delete": "Delete Machine",
    "machine_getDetail": "Query Machine Details",
    "machine_getPage": "Query Machine List",
    "machine_manualOutput": "Manual Output",
    "machine_switchEnvMode": "Switch Environment Mode",
    "machine_transfer": "Machine Transfer",
    "machine_unbindDevice": "Unassign Device",
    "machine_update": "Edit Machine",
    "mainOrder_queryList": "Query Authorization Txn List",
    "mediaResource_add": "Add Media Resource",
    "mediaResource_delete": "Delete Media Resource",
    "mediaResource_getPage": "Query Media Resource List",
    "mediaResource_update": "Edit Media Resource",
    "menuAuth_addAuthBatch": "Batch Add Menu Permissions",
    "menuAuth_getAllMenu": "Query All Menus",
    "menuAuth_getMenuButton": "Query Menu Buttons",
    "menu_add": "Add Menu",
    "menu_delete": "Delete Menu",
    "menu_findAll": "Query All Menus",
    "menu_update": "Edit Menu",
    "openApiGameWayConfig_add": "Add OpenAPI Gateway Config",
    "openApiGameWayConfig_delete": "Delete OpenAPI Gateway Config",
    "openApiGameWayConfig_getByOrgId": "Query OpenAPI Gateway Config By Org ID",
    "openApiGameWayConfig_getByOrgIdAndGatewayType": "Query OpenAPI Gateway Config By Org ID And Gateway Type",
    "openApiGameWayConfig_getPage": "Query OpenAPI Gateway Config List",
    "openApiGameWayConfig_update": "Edit OpenAPI Gateway Config",
    "openApiKey_add": "Add OpenAPI Key",
    "openApiKey_delete": "Delete OpenAPI Key",
    "openApiKey_getDetail": "Query OpenAPI Key Detail",
    "openApiKey_getPage": "Query OpenAPI Key List",
    "openApiKey_resetPassword": "Reset OpenAPI Key Password",
    "openApiKey_update": "Edit OpenAPI Key",
    "oper_addOper": "Add Operator",
    "oper_del": "Delete Operator",
    "oper_findPageOper": "Query Operator List",
    "oper_findPageSubOper": "Query Sub-Operator List",
    "oper_resetPassWord": "Reset Password",
    "oper_update": "Edit Operator",
    "order_queryList": "Query Txn List",
    "orgPayChannel_add": "Add Payment Channel",
    "orgPayChannel_delete": "Delete Payment Channel",
    "orgPayChannel_getPage": "Query Payment Channel List",
    "orgPayChannel_update": "Edit Payment Channel",
    "orgPayMethod_add": "Add Payment Method",
    "orgPayMethod_delete": "Delete Payment Method",
    "orgPayMethod_getPage": "Query Payment Method List",
    "orgPayMethod_update": "Edit Payment Method",
    "orgPayPackageChannel_add": "Add Payment Provider",
    "orgPayPackageChannel_delete": "Delete Payment Provider",
    "orgPayPackageChannel_getPage": "Query Payment Provider List",
    "orgPayPackageChannel_update": "Edit Payment Provider",
    "orgPayPackageMethod_add": "Add Payment Template Method",
    "orgPayPackageMethod_delete": "Delete Payment Template Method",
    "orgPayPackageMethod_getPage": "Query Payment Template Method List",
    "orgPayPackageMethod_getPayMethodsByChannel": "Get Org Package Pay Methods By Channel",
    "orgPayPackageMethod_update": "Edit Payment Template Method",
    "orgPayPackage_add": "Add Payment Template",
    "orgPayPackage_delete": "Delete Payment Template",
    "orgPayPackage_getPage": "Query Payment Template List",
    "orgPayPackage_update": "Edit Payment Template",
    "org_delete": "Delete Agency",
    "org_getDeviceCountByOrg": "Query Agency Device Count",
    "org_getOrgDetail": "Query Organization Details",
    "org_getTreeList": "Query Organization Tree List",
    "org_initNewOrg": "Initialize New Organization",
    "org_update": "Edit Organization",
    "payChannel_add": "Add Payment Channel",
    "payChannel_delete": "Delete Payment Channel",
    "payChannel_getDetailPage": "Query Payment Channel Detail List",
    "payChannel_getPage": "Query Payment Channel List",
    "payChannel_update": "Edit Payment Channel",
    "payMethodChannelProduct_add": "Add Payment Method Channel Product",
    "payMethodChannelProduct_delete": "Delete Payment Method Channel Product",
    "payMethodChannelProduct_getPage": "Query Payment Method Channel Product List",
    "payMethodChannelProduct_getPayMethodWithProductsPage": "Query Payment Methods and Related Channel Products",
    "payMethodChannelProduct_update": "Edit Payment Method Channel Product",
    "payMethod_add": "Add Payment Method",
    "payMethod_delete": "Delete Payment Method",
    "payMethod_getPage": "Query Payment Method List",
    "payMethod_update": "Edit Payment Method",
    "permissionGroupRel_add": "Add Permission Group Relation",
    "permissionGroupRel_delete": "Delete Permission Group Relation",
    "permissionGroupRel_getMenuButton": "Query Permission Group Menu Button",
    "permissionGroupRel_getPage": "Query Permission Group Relation List",
    "permissionGroupRel_sync": "Sync Permission Group Relation",
    "permissionGroupRel_update": "Edit Permission Group Relation",
    "permissionGroup_add": "Add Permission Group",
    "permissionGroup_delete": "Delete Permission Group",
    "permissionGroup_getPage": "Query Permission Group List",
    "permissionGroup_update": "Edit Permission Group",
    "platProduct_add": "Add Platform Product",
    "platProduct_delete": "Delete Platform Product",
    "platProduct_getPage": "Query Platform Products",
    "platProduct_update": "Update Platform Product",
    "qrCode_add": "Add QR Code",
    "qrCode_generate": "Generate QR Code",
    "qrCode_getPage": "Query QR Code List",
    "qrCode_unbindById": "Unassign QR Code",
    "qrCode_update": "Edit QR Code",
    "refundApply_audit": "Audit Refund Application",
    "refundApply_detail": "View Refund Application Detail",
    "refundApply_queryList": "Query Refund Application List",
    "refundApply_submit": "Submit Refund Application",
    "refundOrder_create": "Create Refund Txn",
    "refundOrder_queryList": "Query Refund Txn List",
    "rolePermissionGroupRel_add": "Add Role Permission Group Relation",
    "rolePermissionGroupRel_delete": "Delete Role Permission Group Relation",
    "rolePermissionGroupRel_getPage": "Query Role Permission Group Relation List",
    "rolePermissionGroupRel_update": "Edit Role Permission Group Relation",
    "role_add": "Add Role",
    "role_delete": "Delete Role",
    "role_get": "Query Role",
    "role_getAllRole": "Query All Roles",
    "role_roleDetail": "Query Role Details",
    "role_update": "Edit Role",
    "sysParams_add": "Add System Parameter",
    "sysParams_findByParamName": "Query by Parameter Name",
    "sysParams_getAllList": "Query All System Parameters",
    "sysParams_update": "Edit System Parameter",
    "test(空按钮 勿删)": "Test Button",
    "voidOrder_queryList": "Query Void Txn List",
    "app_upload": "Upload OTA File",
    "app_deleteFile": "Delete OTA File",
    "app_files": "Query OTA File List",
    "app_update_app": "Update OTA File",
    "app_getLogPage": "Query Device Update Log List"
  },
  "router": {
    "agencyManagement": "Galaxy Management",
    "authorization-order": "Authorizations Transactions",
    "businessIntelligence": "Business Intelligence",
    "countryManagement": "Country Management",
    "currencyManagement": "Currency Management",
    "dashboard": "Dashboard",
    "development": "Development Center",
    "deviceConfigTemplate": "Device Config Template",
    "deviceManagement": "Device Management",
    "deviceModelConfig": "Device Module Config",
    "deviceTagManagement": "Machine Tag Management",
    "deviceTransferLog": "Device Transfer Log",
    "deviceTypeManagement": "Device Type Management",
    "dictionaryManagement": "Dictionary Management",
    "login": "Login",
    "machine-transfer-log": "Machine Transfer Log",
    "machineManagement": "Machine Management",
    "machineTypeManagement": "Machine Type Management",
    "mediaResourceManagement": "Media Resource Management",
    "menuManagement": "Menu Management",
    "myAccount": "My Account",
    "operation": "Operations",
    "operation-log-management": "Operation Log Management",
    "operationLogManagement": "Operation Log Management",
    "otaManagement": "OTA Management",
    "paymentMethodManagement": "Payment Method Management",
    "paymentProviderManagement": "Payment Provider Management",
    "permissionGroupManagement": "Permission Group Management",
    "platProductManagement": "Platform Business Products",
    "platform": "Platform",
    "qrCodeTransferLog": "QR Code Transfer Log",
    "qrcodeStickerManagement": "QR Sticker Management",
    "refund-apply-management": "Refund Application Management",
    "report": "Reports",
    "roleManagement": "Role Management",
    "salesAnalysis": "Sales Analysis",
    "sales-by-machine": "Sales By Machine",
    "salesByMachine": "Sales By Machine",
    "setting": "Setting",
    "system": "System",
    "systemCenter": "System Center",
    "systemParameterManagement": "System Parameter Management",
    "systemUserManagement": "Users Management",
    "transaction-order": "Transactions Report",
    "transactionReport": "Transactions Report",
    "transactions": "Transactions",
    "userManagement": "User Management"
  },
  "setting": {
    "breadcrumb": "Breadcrumb",
    "breadcrumbIcon": "Breadcrumb Icon",
    "clearAndReset": "Clear Cache and Reset",
    "copy": "Copy",
    "copyFailed": "Copy failed",
    "copySuccess": "Copy successful",
    "dynamicRouter": "Dynamic Router",
    "fixedHeader": "Fixed Header",
    "fixedMenu": "Fixed Menu",
    "footer": "Footer",
    "greyMode": "Grey Mode",
    "hamburgerIcon": "Hamburger Icon",
    "headerTheme": "Header Theme",
    "interfaceDisplay": "Interface Display",
    "layout": "Layout",
    "localeIcon": "Locale Icon",
    "logo": "Logo",
    "menuTheme": "Menu Theme",
    "projectSetting": "Project Configuration",
    "reExperienced": "Please log out and log in again to experience",
    "screenfullIcon": "Fullscreen Icon",
    "serverDynamicRouter": "Server Dynamic Router",
    "sizeIcon": "Size Icon",
    "systemTheme": "System Theme",
    "tagsView": "Tags View",
    "tagsViewIcon": "Tags View Icon",
    "theme": "Theme",
    "uniqueOpened": "Menu Accordion"
  },
  "settingsManagement": {
    "operationLogManagement": {
      "businessType": {
        "add": "Add",
        "delete": "Delete",
        "login": "Login",
        "logout": "Logout",
        "unknown": "Unknown",
        "update": "Update"
      },
      "dialog": {
        "basicInfo": "Basic Information",
        "requestInfo": "Request Information",
        "responseInfo": "Response Information",
        "title": "Log Details"
      },
      "logType": {
        "error": "Error",
        "info": "Info",
        "warning": "Warning"
      },
      "messages": {
        "loadDataFailed": "Failed to load log data"
      },
      "searchForm": {
        "browser": "Browser",
        "businessType": "Business Type",
        "dateRange": {
          "endPlaceholder": "End Date",
          "label": "Date Range",
          "separator": "to",
          "startPlaceholder": "Start Date"
        },
        "operateIp": "Operation IP",
        "operateName": "Operator",
        "operateUrl": "Operation URL",
        "success": "Status",
        "systemOs": "Operating System",
        "title": "Log Title"
      },
      "table": {
        "address": "Address",
        "browser": "Browser",
        "businessType": "Business Type",
        "errorMsg": "Error Message",
        "id": "ID",
        "logType": "Log Type",
        "operId": "Operator ID",
        "operateIp": "Operation IP",
        "operateName": "Operator",
        "operateUrl": "Operation URL",
        "operation": "Operation",
        "requestBody": "Request Body",
        "requestMethod": "Request Method",
        "requestParam": "Request Params",
        "responseBody": "Response Body",
        "sign": "Signature",
        "success": "Status",
        "systemOs": "Operating System",
        "time": "Execution Time",
        "title": "Log Title",
        "viewDetail": "Detail"
      },
      "title": "Operation Log Management"
    },
    "roleManagement": {
      "addPermissionGroup": "Add Permission Group",
      "addPermissionGroupFailed": "Failed to add permission group",
      "addPermissionGroupSuccess": "Permission group added successfully",
      "addRole": "Add Role",
      "addRoleDialog": "Add Role",
      "agencyManagement": "Hierarchy Management",
      "availablePermissionGroups": "Available Permission Groups",
      "branchAgent": "Branch Agent",
      "branchAgentAdmin": "Branch Agent Administrator",
      "branchAgentAdminDesc": "Branch agent administrator role",
      "branchAgentOperator": "Branch Agent Operator",
      "branchAgentOperatorDesc": "Branch agent operator role",
      "buttonPermissions": "Button Permissions",
      "buttons": "Buttons",
      "confirmDeleteMessage": "Are you sure to delete role \"{name}\"?",
      "confirmDeleteRole": "Confirm Delete",
      "confirmDeleteRoleMessage": "Are you sure to delete role \"{roleName}\"?",
      "createFailed": "Create failed",
      "createSuccess": "Create successful",
      "currentMenu": "Current Menu",
      "customer": "Operator",
      "customerAdmin": "Customer Administrator",
      "customerAdminDesc": "Customer level administrator role",
      "customerFinance": "Customer Finance",
      "customerFinanceDesc": "Customer finance role",
      "customerOperator": "Customer Operator",
      "customerOperatorDesc": "Customer operator role",
      "deleteFailed": "Delete failed",
      "deleteRole": "Delete Role",
      "deleteRoleFailed": "Failed to delete role",
      "deleteRoleSuccess": "Role deleted successfully",
      "deleteSuccess": "Delete successful",
      "editRole": "Edit Role",
      "enterGroupName": "Enter group name",
      "enterGroupType": "Enter group type",
      "factory": "Factory",
      "factoryAdmin": "Factory Administrator",
      "factoryAdminDesc": "Factory level administrator role",
      "factoryAgent": "Factory Agent",
      "factoryAgentAdmin": "Factory Agent Administrator",
      "factoryAgentAdminDesc": "Factory agent administrator role",
      "factoryAgentOperator": "Factory Agent Operator",
      "factoryAgentOperatorDesc": "Factory agent operator role",
      "factoryInspector": "Factory Inspector",
      "factoryInspectorDesc": "Factory inspector role",
      "factoryOperator": "Factory Operator",
      "factoryOperatorDesc": "Factory operator role",
      "groupCode": "Group Code",
      "groupName": "Group Name",
      "groupType": "Group Type",
      "help": {
        "parentRole": "Parent role; new roles inherit the hierarchy of the selected parent, available only when creating roles",
        "remark": "Additional notes for the role, can describe responsibilities or usage hints",
        "roleName": "Display name of the role, used to distinguish roles in the system, recommended length 2-100 characters",
        "roleType": "Category of the role, different types determine hierarchy and permission scope"
      },
      "loadButtonDataError": "Failed to load button data",
      "loadMenuTreeError": "Failed to load menu tree",
      "loadParentRoleTreeError": "Failed to load parent role tree",
      "loadPermissionGroupListError": "Failed to load permission group list",
      "loadRoleAuthError": "Failed to load role auth data",
      "loadRolePermissionGroupsError": "Failed to load role permission groups",
      "loadRoleTreeError": "Failed to load role tree",
      "loadingRoleTree": "Loading role tree...",
      "menuButtonPermissions": "Menu and Button Permissions",
      "menuPermissions": "Menu Permissions",
      "menus": "Menus",
      "noAvailablePermissionGroups": "No available permission groups",
      "noButtonsForMenu": "No button permissions for this menu",
      "noPermissionGroups": "No permission groups configured",
      "operationManagement": "Operation Management",
      "parentRole": "Parent Role",
      "permissionDetails": "Permission Details",
      "permissionGroupAlreadyAssociated": "Permission group already associated",
      "permissionGroupList": "Permission Group List",
      "permissionGroupPackages": "Permission Group Packages",
      "permissionPreview": "Permission Preview",
      "permissionSettings": "Permission Settings",
      "plat": "Platform",
      "platAdmin": "Platform Administrator",
      "platAdminDesc": "Platform level administrator role",
      "platAuditor": "Platform Auditor",
      "platAuditorDesc": "Platform auditor role",
      "platSpecialist": "Platform Specialist",
      "platSpecialistDesc": "Platform specialist role",
      "pleaseSelectMenu": "Please select a menu first",
      "previewPermissions": "Preview Permissions",
      "remove": "Remove",
      "removePermissionGroupFailed": "Failed to remove permission group",
      "removePermissionGroupSuccess": "Permission group removed successfully",
      "roleList": "Role List",
      "roleManagement": "Role Management",
      "roleName": "Role Name",
      "roleType": "Role Type",
      "savePermissions": "Save Permissions",
      "savePermissionsFailed": "Failed to save permissions",
      "savePermissionsSuccess": "Permissions saved successfully",
      "selectPermissionGroup": "Select Permission Group",
      "selectRoleFirst": "Please select a role first",
      "systemManagement": "System Management",
      "title": "Role Management",
      "updateFailed": "Update failed",
      "updateSuccess": "Update successful",
      "userManagement": "User Management",
      "viewPermissions": "View Permissions"
    },
    "userManagement": {
      "addOperator": "Add User",
      "addOperatorDialog": "Add User",
      "backupEmail": "Backup Email",
      "belongingOrg": "Organization",
      "companyName": "Company Name",
      "confirmDeleteMessage": "Are you sure to delete operator \"{name}\"?",
      "confirmDisable": "Confirm Disable",
      "confirmDisableMessage": "Are you sure to disable operator \"{name}\"?",
      "confirmEnable": "Confirm Enable",
      "confirmEnableMessage": "Are you sure to enable operator \"{name}\"?",
      "confirmPassword": "Confirm Password",
      "confirmReset": "Confirm Reset",
      "createFailed": "Create failed",
      "createSuccess": "Create successful",
      "customer": "Operator",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Delete successful",
      "disableSuccess": "Disable successful",
      "editOperator": "Edit User",
      "email": "Email",
      "enableSuccess": "Enable successful",
      "factory": "Factory",
      "firstName": "First Name",
      "help": {
        "backupEmail": "Backup email used when the primary mailbox is unavailable",
        "belongingOrg": "Select the organization the operator belongs to; it defines the accessible data scope",
        "companyName": "Company or department name of the operator for quick identification",
        "confirmPassword": "Confirm the new password to ensure both entries match",
        "email": "Primary email address for notifications and password recovery",
        "firstName": "Operator first name, used for display and notifications",
        "lastName": "Operator last name, used for formal communications",
        "loginAccount": "Username used for authentication, supports letters, numbers, underscores, length 3-100 characters",
        "mobile": "Primary mobile number for contact and security verification",
        "newPassword": "New password entered during reset, must satisfy the minimum length rule",
        "operatorName": "Display name of the operator shown across the system; recommend 2-100 characters",
        "password": "Initial login password when creating a user; recommend 6-255 characters with mixed types",
        "role": "Assign a role to determine available menus and button permissions",
        "status": "Operator status; disabled users cannot log in or perform any actions",
        "titleLabel": "Job title or position, e.g., Manager or Support"
      },
      "lastName": "Last Name",
      "loadOrgTreeFailed": "Failed to load organization tree",
      "loadOperatorsFailed": "Failed to load operator data",
      "loadingOrgTree": "Loading organization tree...",
      "loginAccount": "Username",
      "mobile": "Mobile",
      "newPassword": "New Password",
      "operationFailed": "Operation failed",
      "operatorList": "User List",
      "operatorName": "Operator Name",
      "org": "Organization",
      "orgList": "Organization List",
      "password": "Password",
      "plat": "Platform",
      "resetPassword": "Reset Password",
      "resetPasswordDialog": "Reset Password",
      "resetPasswordFailed": "Password reset failed",
      "resetPasswordSuccess": "Password reset successful",
      "role": "Role",
      "searchOrg": "Search organization...",
      "title": "System User Management",
      "titleLabel": "Title",
      "updateFailed": "Update failed",
      "updateSuccess": "Update successful"
    }
  },
  "size": {
    "default": "Default",
    "large": "Large",
    "small": "Small"
  },
  "systemManagement": {
    "countryManagement": {
      "addCountry": "Add Country",
      "addCountryDialog": "Add Country",
      "addFailed": "Failed to add country",
      "addSuccess": "Country added successfully",
      "commaSeparator": "Comma (,)",
      "confirmDeleteMessage": "Are you sure to delete country \"{countryName}\"?",
      "countryCode": "Country Code",
      "countryCodeLabel": "Country Code",
      "countryName": "Country Name",
      "countryNameLabel": "Country Name",
      "culture": "Culture",
      "cultureCode": "Culture Code",
      "cultureCodePlaceholder": "e.g., zh-CN, en-US",
      "cultureCodeTip": "Unique code to identify this culture configuration",
      "cultureLabel": "Culture",
      "cultureOptions": {
        "ar_SA": "Saudi Arabia: Date format DD/MM/YYYY, number separator thousands, currency symbol ﷼",
        "de_DE": "Germany: Date format DD.MM.YYYY, number separator thousands, currency symbol €",
        "en_GB": "United Kingdom: Date format DD/MM/YYYY, number separator thousands, currency symbol £",
        "en_US": "United States: Date format MM/DD/YYYY, number separator thousands, currency symbol $",
        "es_ES": "Spain: Date format DD/MM/YYYY, number separator thousands, currency symbol €",
        "fr_FR": "France: Date format DD/MM/YYYY, number separator thousands, currency symbol €",
        "hi_IN": "India: Date format DD/MM/YYYY, number separator thousands, currency symbol ₹",
        "id_ID": "Indonesia: Date format DD/MM/YYYY, number separator thousands, currency symbol Rp",
        "it_IT": "Italy: Date format DD/MM/YYYY, number separator thousands, currency symbol €",
        "ja_JP": "Japan: Date format YYYY年MM月DD日, number separator thousands, currency symbol ¥",
        "ko_KR": "South Korea: Date format YYYY.MM.DD, number separator thousands, currency symbol ₩",
        "ms_MY": "Malaysia: Date format DD/MM/YYYY, number separator thousands, currency symbol RM",
        "nl_NL": "Netherlands: Date format DD-MM-YYYY, number separator thousands, currency symbol €",
        "pl_PL": "Poland: Date format DD.MM.YYYY, number separator thousands, currency symbol zł",
        "pt_PT": "Portugal: Date format DD/MM/YYYY, number separator thousands, currency symbol €",
        "ru_RU": "Russia: Date format DD.MM.YYYY, number separator thousands, currency symbol ₽",
        "th_TH": "Thailand: Date format DD/MM/YYYY, number separator thousands, currency symbol ฿",
        "tr_TR": "Turkey: Date format DD.MM.YYYY, number separator thousands, currency symbol ₺",
        "vi_VN": "Vietnam: Date format DD/MM/YYYY, number separator thousands, currency symbol ₫",
        "zh_CN": "China: Date format YYYY-MM-DD, number separator thousands, currency symbol ¥"
      },
      "currency": "Currency",
      "currencyPosition": "Currency Symbol Position",
      "currencyPositionAfter": "After (100$)",
      "currencyPositionBefore": "Before ($100)",
      "currencySymbol": "Currency Symbol",
      "dateFormat": "Date Format",
      "dateSeparator": "Date Separator",
      "dateSeparatorPlaceholder": "e.g., -, /, .",
      "dateTimeFormat": "Date & Time Format",
      "defaultCurrencyCode": "Default Currency Code",
      "defaultTimezone": "Default Timezone",
      "defaultTimezoneLabel": "Default Timezone",
      "decimalPlaces": "Decimal Places",
      "decimalSeparator": "Decimal Separator",
      "deleteFailed": "Failed to delete country",
      "deleteSuccess": "Country deleted successfully",
      "dotSeparator": "Dot (.)",
      "dotSeparatorLabel": "Dot Separator",
      "editCountry": "Edit Country",
      "editCountryDialog": "Edit Country",
      "help": {
        "countryCode": "Unique country/region code, ideally an ISO standard; cannot be changed after creation",
        "countryName": "Display name used in UI and search, supports multiple languages",
        "cultureCode": "Culture identifier to reuse date, number, and currency formats, e.g., zh-CN, en-US",
        "currency": "Default currency; the system derives symbol and name based on the code",
        "currencyPosition": "Position of the currency symbol, either before or after the amount",
        "currencySymbol": "Currency symbol, can override the default (e.g., ¥, $)",
        "dateFormat": "Date format such as YYYY-MM-DD or MM/DD/YYYY; affects all date displays",
        "dateSeparator": "Separator used between date components, typically -, /, or .",
        "defaultCurrencyCode": "Default currency code for the country; it can be selected from the list or entered manually even if it is not returned by the list",
        "decimalPlaces": "Default number of decimal places for amounts or percentages",
        "decimalSeparator": "Decimal separator, usually dot (.) or comma (,)",
        "language": "Language associated with this country, affects UI display language",
        "remark": "Additional notes for the country, used for special instructions or configuration",
        "textDirection": "Direction of text display, either left-to-right (ltr) or right-to-left (rtl)",
        "thousandsSeparator": "Thousands separator for grouping large numbers",
        "timeFormat": "Time format, supports 24-hour or 12-hour display",
        "timeFormatTemplate": "Template for time display, e.g., HH:mm:ss or h:mm:ss A",
        "timezone": "Default timezone for time display and calculations; can be selected or entered manually"
      },
      "language": "Language",
      "languageLabel": "Language",
      "languageOptions": {
        "ar_SA": "العربية",
        "de_DE": "Deutsch",
        "en_GB": "English (UK)",
        "en_US": "English (US)",
        "es_ES": "Español",
        "fr_FR": "Français",
        "hi_IN": "हिन्दी",
        "id_ID": "Bahasa Indonesia",
        "it_IT": "Italiano",
        "ja_JP": "日本語",
        "ko_KR": "한국어",
        "ms_MY": "Bahasa Melayu",
        "nl_NL": "Nederlands",
        "pl_PL": "Polski",
        "pt_PT": "Português",
        "ru_RU": "Русский",
        "th_TH": "ไทย",
        "tr_TR": "Türkçe",
        "vi_VN": "Tiếng Việt",
        "zh_CN": "中文（简体）"
      },
      "languageTimezone": "Language & Timezone",
      "loadDataFailed": "Failed to load country data",
      "numberCurrencyFormat": "Number & Currency Format",
      "searchPlaceholder": "Search country code or name...",
      "spaceSeparator": "Space ( )",
      "textDirection": "Text Direction",
      "textDirectionLtr": "Left-to-right (ltr)",
      "textDirectionRtl": "Right-to-left (rtl)",
      "thousandsSeparator": "Thousands Separator",
      "timeFormat": "Time Format",
      "timeFormat12Hour": "12-hour (h:mm:ss A)",
      "timeFormat24Hour": "24-hour (HH:mm:ss)",
      "timeFormatTemplate": "Time Format Template",
      "timezone": "Timezone",
      "timezoneLabel": "Timezone",
      "timezoneOptions": {
        "UTC+0": "UTC+0 (London Time)",
        "UTC+1": "UTC+1 (Paris Time)",
        "UTC+10": "UTC+10 (Sydney Time)",
        "UTC+11": "UTC+11 (Solomon Islands Time)",
        "UTC+12": "UTC+12 (New Zealand Time)",
        "UTC+2": "UTC+2 (Cairo Time)",
        "UTC+3": "UTC+3 (Moscow Time)",
        "UTC+5.5": "UTC+5.5 (New Delhi Time)",
        "UTC+7": "UTC+7 (Bangkok Time)",
        "UTC+8": "UTC+8 (Beijing Time)",
        "UTC+9": "UTC+9 (Tokyo Time)",
        "UTC-10": "UTC-10 (Hawaii Time)",
        "UTC-11": "UTC-11 (Samoa Time)",
        "UTC-3": "UTC-3 (Brazil Time)",
        "UTC-4": "UTC-4 (Venezuela Time)",
        "UTC-5": "UTC-5 (New York Time)",
        "UTC-6": "UTC-6 (Mexico City Time)",
        "UTC-7": "UTC-7 (Denver Time)",
        "UTC-8": "UTC-8 (Los Angeles Time)",
        "UTC-9": "UTC-9 (Alaska Time)"
      },
      "title": "Country Management",
      "updateFailed": "Failed to update country",
      "updateSuccess": "Country updated successfully",
      "viewCountry": "View Country"
    },
    "currencyManagement": {
      "addCurrency": "Add Currency",
      "addCurrencyDialog": "Add Currency",
      "addFailed": "Failed to add currency",
      "addSuccess": "Currency added successfully",
      "confirmDeleteMessage": "Are you sure to delete currency \"{currencyName}\"?",
      "currencyCode": "Currency Code",
      "currencyCodeLabel": "Currency Code",
      "currencyNumericCode": "Currency Numeric Code",
      "currencyNumericCodeLabel": "Currency Numeric Code",
      "currencyName": "Currency Name",
      "currencyNameLabel": "Currency Name",
      "currencySymbol": "Currency Symbol",
      "currencySymbolLabel": "Currency Symbol",
      "decimalPlace": "Decimal Place",
      "decimalPlaceLabel": "Decimal Place",
      "deleteFailed": "Failed to delete currency",
      "deleteSuccess": "Currency deleted successfully",
      "editCurrencyDialog": "Edit Currency",
      "help": {
        "currencyCode": "Unique code for the currency, typically following ISO 4217 standard (e.g., USD, EUR, CNY), cannot be modified after creation, 1-50 characters",
        "currencyNumericCode": "Numeric code of the currency, must be exactly 3 digits and can contain any combination from 0 to 9, such as 156, 840, 978",
        "currencyName": "Display name of the currency, used to identify the currency in the system, such as US Dollar, Euro, Chinese Yuan, etc., 1-100 characters",
        "currencySymbol": "Symbol representation of the currency, such as $, €, ¥, etc., used to display currency amounts in the interface, up to 20 characters",
        "decimalPlace": "Decimal place kept when displaying currency amounts. Available options are 0, 1, and 2, with a default value of 0"
      },
      "loadDataFailed": "Failed to load currency data",
      "searchPlaceholder": "Search currency code or name...",
      "title": "Currency Management",
      "updateFailed": "Failed to update currency",
      "updateSuccess": "Currency updated successfully",
      "validation": {
        "currencyNumericCodeFormat": "Currency numeric code must be exactly 3 digits"
      }
    },
    "deviceConfigTemplate": {
      "addDialogTitle": "Add Device Config Template",
      "addFailed": "Add failed",
      "addField": "Add Field",
      "addSuccess": "Add successful",
      "configJsonLabel": "Config JSON",
      "confirmDeleteMessage": "Are you sure you want to delete this device config template?",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Delete successful",
      "disable": "Disable",
      "editDialogTitle": "Edit Device Config Template",
      "help": {
        "configJson": "Configuration information of the device config template, stored in JSON format",
        "status": "Status of the device config template, normal or disable",
        "templateName": "Display name of the device config template, used to identify the template",
        "templateType": "Type code of the device config template, used to link to device module"
      },
      "jsonPreview": "JSON Preview",
      "keyName": "Key Name",
      "loadDataFailed": "Failed to load data",
      "loadDeviceModelFailed": "Failed to load device model",
      "normal": "Normal",
      "searchByTemplateName": "Search by Template Name",
      "statusLabel": "Status",
      "submitFailed": "Submit failed",
      "templateName": "Template Name",
      "templateNameLabel": "Template Name",
      "templateNo": "Template No",
      "templateType": "Template Type",
      "templateTypeLabel": "Template Type",
      "title": "Device Config Template",
      "updateFailed": "Update failed",
      "updateSuccess": "Update successful"
    },
    "deviceManagement": {
      "NetAccessError": "Net Access Error",
      "NetAccessSuccess": "First Net Access Success",
      "activePulse": "Active Pulse",
      "addConfig": "Add Configuration",
      "addConfigDialog": "Add Configuration",
      "addDevice": "Add Device",
      "addMqtt": "Add MQTT",
      "addPaySource": "Add Payment Source",
      "addSuccess": "Added successfully",
      "addWifi": "Add WIFI",
      "apn": "APN",
      "apnPlaceholder": "e.g.: cmnet",
      "appVersion": "App Version",
      "appVersionPlaceholder": "e.g.: 1.0.1",
      "assignedMachine": "Assigned Machine",
      "boundMachine": "Assigned Machine",
      "authPassword": "Password",
      "authPasswordConfig": "Management Password",
      "baseConfigPush": "Base Config Push",
      "batchAddDevices": "Batch Add Devices",
      "batchCreateFailed": "Batch create failed",
      "batchCreateSuccess": "Batch create successful",
      "belongingOrg": "Belonging Organization",
      "bindTime": "Assignment Time",
      "bindMachine": "Assign Machine",
      "bindMachineDialogTitle": "Assign Machine",
      "bindMachineFailed": "Failed to assign machine",
      "bindMachineSuccess": "Machine successfully assigned",
      "bindingRecord": "Device Assignment History",
      "bluetooth": "Bluetooth",
      "bootVersion": "Boot Version",
      "bootVersionPlaceholder": "e.g.: 1.0.22",
      "ccid": "Device SIM Card ID",
      "cid": "CID",
      "coin": "Coin",
      "coinType": "Coin Type",
      "collapse": "Collapse",
      "commConfig": "Communication Configuration",
      "commandDescription": "Command Description",
      "commandDescriptionLabel": "Command Description",
      "commandDetail": "Command Detail",
      "commandGetConfig": "GetConfig - Get Device Configuration",
      "commandLog": "Log - Set Log Level",
      "commandReboot": "Reboot - Device Restart",
      "commandRecord": "Command Record",
      "commandRestart": "Restart - Boot Restart",
      "commandSendFailed": "Command send failed",
      "commandSendRecord": "Command Send Record",
      "commandSendSuccess": "Command sent successfully",
      "commandSleep": "Sleep - Sleep Mode",
      "commandSyncTime": "Synchronize time - Sync Time",
      "commandType": "Command Type",
      "commandTypeLabel": "Command Type",
      "communicationConfig": "Communication Configuration",
      "configContent": "Configuration Content",
      "configContentLabel": "Configuration Content",
      "configDownload": "Configuration Dispatch",
      "configEmptyTip": "Device configuration is empty, please configure first",
      "configManagement": "Configuration Management",
      "configTemplate": "Configuration Template",
      "configType": "Configuration Type",
      "configTypeLabel": "Configuration Type",
      "confirmAction": "Confirm Action",
      "confirmFetchLogMessage": "Are you sure you want to fetch the device log for {sn}?",
      "confirmDeleteConfigMessage": "Are you sure to delete this configuration?",
      "confirmDeleteMessage": "Are you sure to delete this device?",
      "confirmRebootMessage": "Are you sure you want to reboot this device?",
      "confirmRestartBootMessage": "Are you sure you want to restart boot this device?",
      "confirmUnbind": "Confirm Unassignment",
      "confirmUnbindMessage": "Are you sure you want to unassign device {name}? After unassignment, you can transfer the device.",
      "creator": "Creator",
      "deleteConfig": "Delete",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Deleted successfully",
      "deviceAlreadyBoundMessage": "This device is already assigned. Do you want to unassign and transfer it?",
      "deviceCommandSend": "Device Command Send",
      "deviceConfig": "Device Configuration",
      "deviceCount": "Device Count",
      "deviceModel": "Device Model",
      "deviceModelPlaceholder": "e.g.: VP10",
      "deviceName": "Device Name",
      "deviceProvider": "Device Provider",
      "communicationModule": "Communication Module",
      "deviceSN": "Device Serial Number",
      "deviceSNPlaceholder": "e.g.: VP10250907610001",
      "deviceSource": "Device Source",
      "deviceSourceInside": "Internal Setup",
      "deviceSourceOutside": "External Device",
      "deviceInfoQr": "Device Info QR",
      "qrCodeDialogTitle": "Device Info QR Code",
      "qrCodeLink": "Link",
      "qrCodeImage": "QR Code",
      "qrCodeGenerating": "Generating QR code...",
      "noQrCodeLink": "No link to copy",
      "copySuccess": "Copy successful",
      "copyFailed": "Copy failed",
      "generateQrCodeLinkFailed": "Failed to generate QR code link",
      "generateQrCodeImageFailed": "Failed to generate QR code image",
      "deviceInfoQrNoDevice": "Please save the device first before generating the QR code",
      "deviceType": "Device Type",
      "device_batchRegister": "Batch Register Device",
      "dialnum": "Dial Number",
      "dialnumPlaceholder": "Default: *99***3#",
      "displaySupport": "Display Support",
      "downloadConfig": "Dispatch Configuration",
      "downloadExample": "Download Example File",
      "downloadFailed": "Download failed",
      "downloadSuccess": "Download successful",
      "downloadTip": "Download example file and fill in device information according to the format, then upload",
      "downloadingExample": "Downloading example file...",
      "duplicateConfigType": "This device already has a configuration of this type. Each configuration type can only have one record",
      "editConfigDialog": "Edit Configuration",
      "enterAuthPassword": "Enter management password",
      "enterCID": "Please enter CID",
      "enterDialNum": "Please enter dial number",
      "enterMQTTIP": "Please enter MQTT IP",
      "enterMQTTPassword": "Please enter MQTT password",
      "enterMQTTUser": "Please enter MQTT username",
      "enterPIN": "Please enter PIN",
      "enterPassword": "Please enter password",
      "enterTransferRemark": "Please enter transfer reason",
      "enterUsername": "Please enter username",
      "enterWifiPassword": "Please enter WiFi password",
      "enterWifiPassword2": "Please enter WiFi password 2",
      "enterWifiSSID": "Please enter WiFi SSID",
      "enterWifiSSID2": "Please enter WiFi SSID 2",
      "exampleFile": "Device Batch Import Example.xlsx",
      "expand": "Expand",
      "extendConfigPush": "Extend Config Push",
      "fourGConfig": "4G Configuration",
      "fourGEnable": "4G Enable",
      "fourGSupport": "4G Support",
      "hardwareConfig": "Hardware Configuration",
      "hardwareSupportHint": "0 not supported / >1 supported",
      "help": {
        "apn": "APN (Access Point Name) of the 4G network, used to configure the access point of the 4G network, such as cmnet, 3gnet, etc.",
        "appVersion": "Application version reported by the device, used to display the software version currently running on the terminal and cannot be modified manually",
        "belongingOrg": "Organization to which the device belongs, determines the data access permissions and management scope of the device",
        "cid": "CID (Connection Identifier) of the 4G network, range 0-65535, used to identify the 4G network connection",
        "commandDescription": "Description of the command, used to explain the purpose or reason for sending the command, optional",
        "commandType": "Type of command to send, such as reboot, sleep, sync time, set log level, etc.",
        "configType": "Type of configuration, such as WiFi configuration, 4G configuration, etc., each type can only have one configuration record",
        "communicationModule": "Communication module used by the device, such as 4G, 5G, WiFi, or Ethernet, used to identify its communication capability",
        "deviceName": "Display name of the device, used to identify the device in the system, supports selection from preset options or custom input",
        "deviceProvider": "Manufacturer or provider name of the device, used to identify the device source",
        "deviceSource": "Source type of the device, internal setup means created by the system internally, external device means imported from external systems",
        "deviceInfoQr": "Scan the QR code to view the device information page",
        "deviceType": "Type code of the device, determines the functional characteristics and business rules of the device, must be selected from the device type list",
        "dialnum": "Dial number of the 4G network, used to establish 4G connection, default is *99#",
        "fourGEnable": "4G network switch, when enabled the device will use 4G network connection, when disabled WiFi network will be automatically enabled",
        "moduleType": "Communication module type of the device, such as 4G, 5G, WiFi, Bluetooth, etc., determines the network connection method of the device",
        "orgName": "Organization to which the device belongs, determines the data access permissions and management scope of the device",
        "password": "Password of the 4G network, used for 4G network authentication, 8-16 characters",
        "pin": "PIN code of the 4G SIM card, 4 digits, used to protect SIM card security",
        "remark": "Remarks information of the device, used to record additional notes or comments",
        "serialNumber": "Unique serial number of the device, used to identify the physical device, cannot be modified after creation",
        "serialNumberPattern": "Only letters and numbers are allowed",
        "status": "Operating status of the device, testing means the device is in the testing phase, active means the device can be used normally, inactive means the device is disabled",
        "systemDeviceNo": "System-generated device number, used for internal system identification and management, cannot be manually modified",
        "toOrgLabel": "Target Organization, the device will be transferred to this organization",
        "transferReason": "Transfer Reason, used to explain the reason for transferring the device",
        "username": "Username of the 4G network, used for 4G network authentication, 1-20 characters",
        "wifiEnable": "WiFi network switch, when enabled the device will use WiFi network connection, when disabled 4G network will be automatically enabled",
        "wifiPassword": "Password of the WiFi network, used to connect to the WiFi network, 8-63 characters",
        "wifiSSID": "SSID (Service Set Identifier) of the WiFi network, used to identify the WiFi network, 1-32 characters, supports letters, numbers, underscores and hyphens"
      },
      "hwConfig": "Hardware Configuration",
      "inactivePulse": "Inactive Pulse",
      "lastOfflineTime": "Last Offline Time",
      "lastOnline": "Last Online",
      "lastOnlineNetType": "Last Online Net Type",
      "lastOnlineWifiSsid": "Last Online Wifi SSID",
      "lastOnlineTime": "Last Online Time",
      "netStatus": "Connection Status",
      "loadBindingRecordsFailed": "Failed to load device assignment history",
      "loadBindableMachinesFailed": "Failed to load bindable machines",
      "loadCommandLogsFailed": "Failed to load command logs",
      "loadConfigFailed": "Failed to load configuration",
      "loadConfigsFailed": "Failed to load device configurations",
      "loadDeviceDataFailed": "Failed to load device data",
      "loadDeviceTypesFailed": "Failed to load device types",
      "loadOrgDevicesFailed": "Failed to load organization devices",
      "loadOrgTreeFailed": "Failed to load organization tree",
      "loadingOrgDeviceTree": "Loading org & device tree...",
      "loadTemplatesFailed": "Failed to load templates",
      "log": "Log",
      "logClose": "Close",
      "logError": "Error",
      "logInfo": "Info",
      "logLevel": "Log Level",
      "logLevelClose": "0 - Close",
      "logLevelError": "4 - Error",
      "logLevelInfo": "2 - Info",
      "logLevelTrace": "1 - Trace",
      "logLevelWarn": "3 - Warn",
      "machineConfig": "Machine Configuration",
      "machineConfigAutoDispatch": "PULSE protocol saved successfully, machine configuration auto dispatched",
      "machineConfigDispatchFailed": "PULSE protocol saved successfully, but machine configuration dispatch failed",
      "machineConfigExistsPrompt": "A machine configuration (machine.cfg) already exists for this device. Update the existing configuration?",
      "machineConfigUpdateSuccess": "Machine configuration updated",
      "machineName": "Machine Name",
      "moduleType": "Module Type",
      "mqttConfig": "MQTT Configuration",
      "mqttIP": "IP Address",
      "mqttIPPlaceholder": "e.g.: 192.168.1.100",
      "mqttKeepalive": "Keepalive",
      "mqttKeepalivePlaceholder": "60",
      "mqttPassword": "Password",
      "mqttPasswordPlaceholder": "8-16 characters",
      "mqttPort": "Port",
      "mqttPortPlaceholder": "1883",
      "mqttQos": "QoS",
      "mqttUser": "Username",
      "mqttUserPlaceholder": "1-20 characters",
      "netAccessStatus": "First Net Access Status",
      "netAccessTime": "First Net Access Time",
      "netCombineError": "Net Combine Error",
      "netCombineStatus": "Net Combine Status",
      "netCombineSuccess": "Net Combine Success",
      "netCombineTime": "Net Combine Time",
      "noAvailableConfigType": "All configuration types already exist for this device. No available type to add",
      "noCommandHistory": "No command history",
      "noConfigHistory": "No configuration history",
      "noMachineConfig": "No Machine Configuration",
      "noTransferOrg": "No transferable organization",
      "notNetAccess": "Not Net Access",
      "notNetCombine": "Not Net Combine",
      "notRegistered": "Not Registered",
      "notSupport": "Not Support",
      "notSupported": "Not Supported",
      "off": "Off",
      "on": "On",
      "operateTime": "Operation Time",
      "operatorName": "Operator Name",
      "optional": "Optional",
      "orgDeviceTree": "Organization Device Tree",
      "orgName": "Organization Name",
      "osVersion": "OS Version",
      "osVersionPlaceholder": "e.g.: 5.0.21",
      "paper": "Paper",
      "parseTemplateFailed": "Failed to parse template",
      "password": "Password",
      "passwordPlaceholder": "8-16 characters",
      "paySource": "Payment Source Configuration",
      "pin": "PIN",
      "pinPlaceholder": "4 digits",
      "pleaseSelectDevice": "Please select a device first",
      "port": "Port",
      "professionalMode": "Professional Mode",
      "pulseConfig": "Pulse Configuration",
      "pulseCount": "Pulse Count",
      "pushConfig": "Push Configuration",
      "pushConfigFailed": "Configuration push failed",
      "pushConfigSuccess": "Configuration pushed successfully",
      "downloadDeviceLog": "Download Log",
      "fetchLog": "Fetch Log",
      "fetchLogFail": "Fail",
      "fetchLogMessage": "Fetch Result",
      "fetchLogRecord": "Fetch Log Record",
      "fetchLogDeviceOffline": "Device is offline, cannot fetch log",
      "fetchLogStarted": "Fetch log request submitted",
      "fetchLogStartFailed": "Failed to submit fetch log request",
      "fetchLogSuccess": "Success",
      "fetchLogSuccessMessage": "Device log fetched successfully",
      "fetchLogReload": "Reload",
      "fetchLogDownloading": "Fetching log...",
      "fetchLogDownloadFailed": "Failed to download device log",
      "fetchLogDownloadMissing": "Device log file does not exist or has expired",
      "fetchLogUrlMissing": "Log download URL is missing",
      "fetchingLog": "Fetching",
      "loadFetchLogRecordsFailed": "Failed to load fetch log records",
      "qosAtLeastOnce": "1 - At Least Once",
      "qosAtMostOnce": "0 - At Most Once",
      "qosExactlyOnce": "2 - Exactly Once",
      "reRegister": "Re-register",
      "reRegisterFailed": "Re-register Failed",
      "reRegisterSuccess": "Re-register Success",
      "reboot": "Reboot",
      "rebootCommandSent": "Reboot command sent successfully",
      "register": "Register",
      "registerStatus": "Register Status",
      "registerSuccess": "Register Success",
      "removeMqtt": "Remove",
      "removePaySource": "Remove",
      "removeWifi": "Remove",
      "requestJson": "Request JSON",
      "requestParams": "Request Parameters",
      "requestParamsLabel": "Request Parameters",
      "responseJson": "Response JSON",
      "responseResult": "Response Result",
      "restartBoot": "Restart",
      "restartBootCommandSent": "Restart boot command sent successfully",
      "resultStatus": "Result Status",
      "rssi": "Signal Strength",
      "saveAuthConfigSuccess": "Management password saved successfully",
      "saveConfigFailed": "Failed to save configuration",
      "saveFailed": "Save failed",
      "saveFourGConfigSuccess": "4G configuration saved successfully",
      "saveMqttConfigSuccess": "MQTT configuration saved successfully",
      "savePulseConfigSuccess": "Terminal communication configuration saved successfully",
      "saveSuccess": "Saved successfully",
      "saveWifiConfigSuccess": "WiFi configuration saved successfully",
      "searchPlaceholder": "Search organization or device",
      "selectAPN": "Select APN",
      "selectDateTime": "Select Date Time",
      "selectDeviceFirst": "Please select a device first",
      "selectFile": "Select File",
      "selectFileFirst": "Please select a file first",
      "selectOrgFirst": "Please select an organization first",
      "selectOrgOrDevice": "Please select device",
      "selectQOS": "Select QOS",
      "selectSourceOrgName": "Select Source Organization Name",
      "selectTargetOrg": "Please select target organization",
      "selectTemplate": "Select Template",
      "send": "Send",
      "sendCommand": "Send Command",
      "sendCommandDialog": "Send Command",
      "sendCommandFailed": "Failed to send command",
      "sendCommandSuccess": "Command sent successfully",
      "serialNumber": "Serial Number",
      "sleep": "Sleep",
      "sn": "SN",
      "sourceDeviceType": "Source Device Type",
      "sourceOrgName": "Source Organization Name",
      "status": "Status",
      "statusActive": "Active",
      "statusTest": "Testing",
      "statusUnActive": "Inactive",
      "supported": "Supported",
      "syncTime": "Sync Time",
      "synchronizeTime": "Synchronize Time",
      "sysConfig": "System Configuration",
      "sysDeviceNo": "System Device No",
      "systemDeviceNo": "System Device Number",
      "targetOrgName": "Target Organization Name",
      "terminalCommunicationConfig": "Terminal Communication Configuration",
      "title": "Device Management",
      "toOrgLabel": "Target Organization",
      "transferDevice": "Transfer Device",
      "transferFailed": "Device transfer failed",
      "transferReason": "Transfer Reason",
      "transferRecord": "Transfer Record",
      "transferSuccess": "Device transfer successful",
      "confirmUnbindMachineMessage": "Are you sure you want to unassign machine {name}?",
      "selectMachinePlaceholder": "Please enter and select a machine",
      "unbindFailed": "Failed to unassign device",
      "unbindMachine": "Unassign Machine",
      "unbindSuccess": "Device successfully unassigned",
      "unbindTime": "Unassignment Time",
      "unitValue": "Unit Value",
      "updateSuccess": "Updated successfully",
      "upload": "Upload",
      "uploadExcelOnly": "Only Excel or CSV files are allowed!",
      "uploadFile": "Upload File",
      "uploadFileSizeLimit": "File size cannot exceed 2MB!",
      "uploadTip": "Please upload Excel or CSV format files, size not exceeding 2MB",
      "viewMachine": "View Machine",
      "viewMachinePending": "View machine detail is not implemented yet",
      "username": "Username",
      "usernamePlaceholder": "1-20 characters",
      "vcoin": "Virtual Coin",
      "wifiConfig": "WiFi Configuration",
      "wifiEnable": "WiFi Enable",
      "wifiPassword": "WiFi Password",
      "wifiPassword2": "WiFi Password 2",
      "wifiPasswordPlaceholder": "8-63 characters",
      "wifiSSID": "WiFi SSID",
      "wifiSSID2": "WiFi SSID 2",
      "wifiSSIDPlaceholder": "1-32 characters, letters/numbers/underscores/hyphens",
      "wifiSupport": "WiFi Support",
      "wlBand": "4G Band",
      "wlStandard": "4G Standard"
    },
    "deviceModelConfig": {
      "addDialogTitle": "Add Device Module Configuration",
      "addFailed": "Add failed",
      "addKeyValue": "Add Key-Value Pair",
      "addSuccess": "Add successful",
      "configJson": "Config JSON",
      "configJsonLabel": "Config JSON",
      "confirmDeleteMessage": "Are you sure you want to delete this device module configuration?",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Delete successful",
      "description": "Description",
      "editDialogTitle": "Edit Device Module Configuration",
      "exampleValue": "Example Value",
      "help": {
        "configJson": "Configuration information of the device module, stored in JSON format",
        "modelName": "Display name of the device module, used to identify the device module",
        "modelType": "Type code of the device module, used to distinguish different types of devices"
      },
      "jsonPreview": "JSON Preview",
      "keyName": "Key Name",
      "loadDataFailed": "Failed to load data",
      "modelName": "Module Name",
      "modelNameLabel": "Module Name",
      "modelType": "Module Type",
      "modelTypeLabel": "Module Type",
      "submitFailed": "Submit failed",
      "title": "Device Module Configuration",
      "updateFailed": "Update failed",
      "updateSuccess": "Update successful"
    },
    "deviceTagManagement": {
      "addFailed": "Failed to add tag",
      "addSuccess": "Tag added successfully",
      "addTag": "Add Tag",
      "confirmDeleteMessage": "Are you sure to delete tag \"{tagName}\"?",
      "deleteFailed": "Failed to delete tag",
      "deleteSuccess": "Tag deleted successfully",
      "editTag": "Edit Tag",
      "help": {
        "tagName": "Name of the device tag, use concise wording to describe the tag purpose, up to 100 characters"
      },
      "loadDataFailed": "Failed to load tag data",
      "orgId": "Organization ID",
      "tagName": "Tag Name",
      "tagNameLabel": "Tag Name",
      "title": "Machine Tags",
      "updateFailed": "Failed to update tag",
      "updateSuccess": "Tag updated successfully"
    },
    "deviceTransferLog": {
      "batchNo": "Transfer Batch No",
      "endTime": "End Time",
      "loadDataFailed": "Failed to load data",
      "noErrorMessage": "No error message",
      "orgChange": "Organization Change Record",
      "selectEndTime": "Select End Time",
      "selectStartTime": "Select Start Time",
      "startTime": "Start Time",
      "transferReason": "Transfer Reason",
      "transferResult": "Transfer Result"
    },
    "deviceTypeManagement": {
      "addFailed": "Failed to add device type",
      "addSuccess": "Device type added successfully",
      "addTypeDialog": "Add Device Type",
      "confirmDeleteMessage": "Are you sure to delete type \"{typeName}\"?",
      "deleteFailed": "Failed to delete device type",
      "deleteSuccess": "Device type deleted successfully",
      "editTypeDialog": "Edit Device Type",
      "help": {
        "remark": "Remarks information of the device type, can be used to record the characteristics, purpose or usage instructions of the type, maximum 255 characters",
        "typeCode": "Unique code for the device type, used to identify the device type in the system, recommended to use alphanumeric combinations, 1-100 characters",
        "typeName": "Display name of the device type, used to distinguish different types of devices in the system, 1-100 characters"
      },
      "loadDataFailed": "Failed to load device type data",
      "title": "Device Type Management",
      "typeCode": "Type Code",
      "typeCodeLabel": "Type Code",
      "typeName": "Type Name",
      "typeNameLabel": "Type Name",
      "updateFailed": "Failed to update device type",
      "updateSuccess": "Device type updated successfully"
    },
    "otaManagement": {
      "title": "OTA File Management",
      "uploadNewFile": "Upload New File",
      "index": "Index",
      "fileName": "File Name",
      "fileSize": "File Size",
      "uploadTime": "Upload Time",
      "deviceList": "Device List",
      "selectedFile": "Selected File:",
      "noFileSelected": "No file selected for update",
      "deviceSN": "Device SN",
      "netStatus": "Net Status",
      "orgName": "Organization Name",
      "selectOrgName": "Select Organization",
      "updateFile": "Update File",
      "uploadSuccess": "Upload successful",
      "uploadFailed": "Upload failed",
      "onlySupport": "Only .rbl, .tpk, .p1z formats are supported",
      "dangerousFileNotAllowed": "Dangerous file formats such as executables are not allowed",
      "getFileListFailed": "Failed to get file list",
      "deleteSuccess": "Delete successful",
      "deleteFailed": "Delete failed",
      "getDeviceListFailed": "Failed to get device list",
      "pleaseSelectFileFirst": "Please select an OTA file first",
      "updateCommandSent": "Update command issued",
      "updateFailed": "Update failed",
      "batchUpdate": "Batch Upgrade",
      "batchUpdateConfirm": "Are you sure you want to batch upgrade these {count} devices?",
      "selectedDeviceCount": "{count} devices selected",
      "pleaseSelectAtLeastOneDevice": "Please select at least one device",
      "batchUpdateMaxDevices": "You can select up to 10 devices for batch upgrade",
      "batchUpdateSameDeviceType": "Selected devices must have the same device type",
      "batchUpdateOnlineOnly": "Only online devices can be selected for batch upgrade",
      "batchUpdateSubmitted": "Upgrade requests submitted for {count} devices",
      "batchUpdatePartial": "Partial submission succeeded, {submitted} succeeded and {failed} failed",
      "batchUpdateAllFailed": "Batch upgrade submission failed",
      "batchUpdateFailed": "Batch upgrade failed",
      "all": "All",
      "noPermissionUpload": "Upload OTA File Permission",
      "noPermissionDelete": "Delete OTA File Permission",
      "noPermissionUpdate": "Update OTA File Permission",
      "updateConfirm": "Are you sure you want to send an update command to this device?",
      "updateTypeTitle": "Select Upgrade Type",
      "updateTypeApp": "App",
      "updateTypeWifiFw": "WiFi firmware package",
      "wifiFirmwareBinOnly": "The WiFi firmware package must be a .bin file",
      "refresh": "Refresh",
      "fileSizeExceed": "File size cannot exceed {size}MB",
      "updateLog": "Update Log",
      "updateLogList": "Device Update Log List",
      "updateStatus": "Status",
      "updateMessage": "Message",
      "updateTime": "Time",
      "success": "success",
      "fail": "fail",
      "updating": "updating",
      "getLogFailed": "Failed to get log"
    },
    "dictionaryManagement": {
      "addDictDialog": "Add Dictionary Category",
      "addFailed": "Failed to add",
      "addItemDialog": "Add Dictionary Item",
      "addSuccess": "Added successfully",
      "confirmDeleteDictMessage": "Are you sure to delete dictionary category \"{dictText}\"?",
      "confirmDeleteItemMessage": "Are you sure to delete dictionary item \"{itemText}\"?",
      "deleteFailed": "Failed to delete",
      "deleteFailedMissingId": "Delete failed: missing ID",
      "deleteSuccess": "Deleted successfully",
      "dictCategory": "Dictionary Category",
      "dictCode": "Dictionary Code",
      "dictCodeLabel": "Dictionary Code",
      "dictItem": "Dictionary Item",
      "dictText": "Dictionary Name",
      "dictTextLabel": "Dictionary Name",
      "editDictDialog": "Edit Dictionary Category",
      "editItemDialog": "Edit Dictionary Item",
      "help": {
        "dictCode": "Unique code for the dictionary category, used to identify the dictionary category in the system, cannot be modified after creation, 1-60 characters",
        "dictText": "Display name of the dictionary category, used to identify and display the dictionary category in the system, 1-60 characters",
        "itemCode": "Unique code for the dictionary item, used to identify the dictionary item in the system, cannot be modified after creation, 1-60 characters",
        "itemText": "Display name of the dictionary item, used to identify and display the dictionary item in the system, 1-60 characters"
      },
      "itemCode": "Item Code",
      "itemCodeLabel": "Item Code",
      "itemText": "Item Name",
      "itemTextLabel": "Item Name",
      "loadDictDataFailed": "Failed to load dictionary category data",
      "loadItemDataFailed": "Failed to load dictionary item data",
      "title": "Dictionary Management",
      "updateFailed": "Failed to update",
      "updateSuccess": "Updated successfully"
    },
    "machineTypeManagement": {
      "addConfigItem": "Add Config Item",
      "addConfigSection": "Add Config Section",
      "addFailed": "Failed to add machine type",
      "addSuccess": "Machine type added successfully",
      "addTypeDialog": "Add Machine Type",
      "config": "Config",
      "configItems": "Config Items",
      "configSection": "Config Section",
      "configSectionLabel": "Config Section",
      "confirmDeleteMessage": "Are you sure to delete type \"{typeName}\"?",
      "deleteFailed": "Failed to delete machine type",
      "deleteFailedMissingId": "Delete failed: missing ID",
      "deleteSuccess": "Machine type deleted successfully",
      "editTypeDialog": "Edit Machine Type",
      "enterResourceUrl": "Please enter resource URL",
      "help": {
        "configSection": "Select config section to group configuration items",
        "key": "The key of the configuration item, used to identify the configuration in the system",
        "remark": "Additional notes for the machine type, can be used to record characteristics or descriptions",
        "typeCode": "Unique code for the machine type, use letters or numbers, cannot be changed after creation",
        "typeName": "Display name of the machine type, used to distinguish different types in the system",
        "value": "The value of the configuration item, corresponding to the specific setting of the key"
      },
      "keyLabel": "Key",
      "loadDataFailed": "Failed to load machine type data",
      "machineSection": "Machine Config",
      "removeConfigItem": "Remove Config Item",
      "title": "Machine Type Management",
      "typeCode": "Type Code",
      "typeCodeLabel": "Type Code",
      "typeName": "Type Name",
      "typeNameLabel": "Type Name",
      "updateFailed": "Failed to update machine type",
      "updateSuccess": "Machine type updated successfully",
      "valueLabel": "Value",
      "viewConfig": "View Config"
    },
    "mediaResourceManagement": {
      "browserNotSupportVideo": "Your browser does not support video playback",
      "clickUploadOrDrag": "Click to upload or drag file to this area",
      "confirmDeleteMessage": "Are you sure to delete media resource \"{resourceName}\"?",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Delete successful",
      "editMediaResource": "Edit Media Resource",
      "enterResourceUrl": "Please enter resource URL",
      "help": {
        "resourceDescription": "Description information of the resource, used to explain the purpose, content or notes of the resource, maximum 255 characters",
        "resourceName": "Display name of the resource, used to identify and display the resource in the system, up to 100 characters",
        "resourceType": "Type of the resource, select image or video, different types support different file formats and size limits",
        "resourceUrl": "URL address of the resource, can be automatically generated by uploading a file, or manually enter an external URL link, maximum 255 characters"
      },
      "image": "Image",
      "imageLoadFailed": "Image load failed",
      "imagePreview": "Image Preview",
      "imageSizeLimit": "Image size cannot exceed 1MB!",
      "loadDataFailed": "Failed to load data",
      "loadFailed": "Load failed",
      "noDescription": "No description",
      "noPreview": "No preview",
      "onlyImageFiles": "Only image files can be uploaded!",
      "onlyVideoFiles": "Only video files can be uploaded!",
      "orInputUrl": "Or input URL:",
      "preview": "Preview",
      "resourceDescription": "Resource Description",
      "resourceName": "Resource Name",
      "resourceType": "Resource Type",
      "resourceUpload": "Resource Upload",
      "resourceUrl": "Resource URL",
      "searchPlaceholder": "Search resource name or description...",
      "selectResourceType": "Select Resource Type",
      "supportFormats": "Support {formats} format, file size not exceeding {size}",
      "title": "Media Resource Management",
      "unknownResourceType": "Unknown resource type",
      "updateSuccess": "Update successful",
      "uploadFailed": "Upload failed, please try again",
      "uploadFailedMessage": "{type} upload failed",
      "uploadMediaResource": "Upload Media Resource",
      "uploadResource": "Upload Resource",
      "uploadSuccess": "Upload successful",
      "uploadSuccessMessage": "{type} upload successful",
      "video": "Video",
      "videoPreview": "Video Preview",
      "videoSizeLimit": "Video size cannot exceed 100MB!",
      "videoUrl": "Video URL"
    },
    "menuManagement": {
      "actionUrlLabel": "Request URL",
      "addButton": "Add Button",
      "addButtonTitle": "Add Button",
      "addMenu": "Add Menu",
      "addMenuTitle": "Add Menu",
      "belongMenu": "Belong Menu",
      "buttonCode": "Button Code",
      "buttonCodeLabel": "Button Code",
      "buttonList": "Button List",
      "buttonName": "Button Name",
      "buttonNameLabel": "Button Name",
      "createFailed": "Create failed",
      "createSuccess": "Create successful",
      "deleteButtonConfirm": "Are you sure to delete button \"{buttonName}\"?",
      "deleteFailed": "Delete failed",
      "deleteFailedMissingId": "Delete failed, missing menu ID",
      "deleteMenuConfirm": "Are you sure to delete menu \"{menuName}\"?",
      "deleteSuccess": "Delete successful",
      "deleteTitle": "Confirm Delete",
      "editButtonTitle": "Edit Button",
      "editMenuTitle": "Edit Menu",
      "help": {
        "actionUrl": "Backend API interface address corresponding to the button, used to execute the operation corresponding to the button",
        "belongMenu": "Menu to which the button belongs, the button will be displayed under this menu, used for permission management and function organization",
        "buttonCode": "Unique code for the button, used for permission control and API calls, recommended to use underscore naming, 2-128 characters",
        "buttonName": "Display name of the button, used to identify and display the button in the system, 2-60 characters",
        "isHidden": "Whether the menu is hidden in the navigation bar, hidden menu can still be accessed via URL but will not be displayed in the navigation bar",
        "menuCode": "Unique code for the menu, used to identify the menu in the system, recommended to use alphanumeric and underscore combinations, 2-60 characters",
        "menuIcon": "Icon identifier of the menu, using icon library icon names, such as ep:menu, ep:home, etc.",
        "menuName": "Display name of the menu, used to display in the navigation bar and system, 2-60 characters",
        "menuUrl": "Route path corresponding to the menu, used for frontend route navigation, must start with /",
        "parentMenu": "Parent menu of the menu, used to build the hierarchical structure of menus, root menu has no parent menu",
        "remarks": "Remarks information of the menu, used to record the purpose, description or other notes of the menu",
        "sort": "Sort transaction of the menu, smaller values appear first, range 0-9999",
        "status": "Status of the menu, enabled menu will be displayed in the system, disabled menu will be invisible"
      },
      "hidden": "Hidden",
      "isHidden": "Is Hidden",
      "loadButtonDataFailed": "Failed to load button data",
      "loadMenuDataFailed": "Failed to load menu data",
      "menuCode": "Menu Code",
      "menuDisabled": "Disabled",
      "menuEnabled": "Enabled",
      "menuIcon": "Menu Icon",
      "menuList": "Menu List",
      "menuName": "Menu Name",
      "menuUrl": "Menu URL",
      "notHidden": "Not Hidden",
      "parentMenu": "Parent Menu",
      "requestUrl": "Request URL",
      "searchMenu": "Search menu...",
      "selectMenuFirst": "Please select a menu first",
      "sort": "Sort",
      "title": "System Menu Management",
      "updateFailed": "Update failed",
      "updateSuccess": "Update successful"
    },
    "orgTagManagement": {
      "addDialogTitle": "Add Organization Tag",
      "addTag": "Add Tag",
      "deleteConfirm": "Are you sure to delete tag \"{tagName}\"?",
      "deleteTitle": "Confirm Delete",
      "editDialogTitle": "Edit Organization Tag",
      "editTag": "Edit Tag",
      "searchPlaceholder": "Search tag name...",
      "tagName": "Tag Name",
      "tagNameLabel": "Tag Name",
      "title": "Organization Tag Management"
    },
    "paymentMethodManagement": {
      "addMethod": "Add Payment Method",
      "addMethodDialog": "Add Payment Method",
      "addSuccess": "Payment method added successfully",
      "allChannels": "All Channels",
      "associate": "Associate",
      "associateFailed": "Association failed",
      "associateSuccess": "Association successful",
      "associatedChannelProducts": "Associated Channel Products",
      "availableProducts": "Available Channel Products",
      "clickUploadLogo": "Click to upload logo",
      "confirmDeleteMethodMessage": "Are you sure to delete payment method \"{methodName}\"? All associations will also be deleted.",
      "currentMethod": "Current Payment Method",
      "deleteFailed": "Failed to delete payment method",
      "deleteSuccess": "Payment method deleted successfully",
      "editMethodDialog": "Edit Payment Method",
      "fixedRate": "Fixed Rate",
      "help": {
        "methodCode": "Unique code for the payment method, used to identify the payment method in the system, recommended to use alphanumeric and underscore combinations, maximum 50 characters",
        "methodLogo": "Logo icon of the payment method, supports uploading image files or using icon library icon identifiers (such as ep:credit-card), recommended size 40x40px, image size not exceeding 1MB",
        "methodName": "Display name of the payment method, used to identify and display the payment method in the system, such as Alipay, WeChat Pay, etc., maximum 100 characters"
      },
      "imageSizeLimit": "Image size cannot exceed 1MB!",
      "loadDataFailed": "Failed to load payment method data",
      "logoCleared": "Logo cleared",
      "logoHint": "Support image file upload, recommended size: 40x40px",
      "logoLoadFailed": "Logo load failed",
      "logoUploadFailed": "Logo upload failed",
      "logoUploadSuccess": "Logo upload successful",
      "manageProducts": "Manage Products",
      "manageProductsDialog": "Manage Associated Products",
      "methodCode": "Payment Method Code",
      "methodLogo": "Payment Method Logo",
      "methodName": "Payment Method Name",
      "noAssociations": "No associated channel products, click \"Manage Products\" to associate",
      "noMethodsDescription": "No payment method data available, click \"Add\" button to create the first payment method",
      "onlyImageFiles": "Only image files can be uploaded!",
      "percentageRate": "Percentage Rate",
      "removeAssociation": "Remove Association",
      "removeAssociationFailed": "Failed to remove association",
      "removeAssociationSuccess": "Remove association successful",
      "searchPlaceholder": "Search payment method name or code...",
      "selectChannelFilter": "Select Channel Filter",
      "title": "Payment Method Management",
      "updateSuccess": "Payment method updated successfully"
    },
    "paymentProviderManagement": {
      "addChannel": "Add Provider",
      "addChannelDialog": "Add Payment Provider",
      "addConfigItem": "Add Config Item",
      "addProduct": "Add Product",
      "addProductDialog": "Add Provider Product",
      "addRequiredParam": "Add Required Parameter",
      "addRequiredParamHint": "Click \"Add Required Parameter\" to start configuring",
      "addSuccess": "Added successfully",
      "belongingChannel": "Belonging Provider",
      "booleanType": "Boolean",
      "channelCode": "Provider Code",
      "channelConfig": "Provider Configuration",
      "channelConfigLabel": "Provider Configuration",
      "channelLogo": "Provider Logo",
      "channelName": "Provider Name",
      "channelProducts": "Provider Products",
      "clickAddConfig": "Click \"Add Config Item\" to start configuring",
      "clickUploadLogo": "Click to upload logo",
      "completeConfigItems": "Please complete all config items",
      "configAction": "Action",
      "configDetailDialog": "Provider Configuration Details",
      "configItemManagement": "Config Item Management",
      "configKey": "Config Key",
      "configKeyCannotBeRepeated": "Config key cannot be repeated",
      "configType": "Type",
      "configValue": "Config Value",
      "confirmDeleteChannelMessage": "Are you sure to delete payment channel \"{channelName}\"? All products under this channel will also be deleted.",
      "confirmDeleteProductMessage": "Are you sure to delete product \"{productName}\"?",
      "deleteFailed": "Delete failed",
      "deleteProductFailed": "Failed to delete product",
      "deleteSuccess": "Deleted successfully",
      "editChannel": "Edit Provider",
      "editChannelDialog": "Edit Payment Provider",
      "editProductDialog": "Edit Provider Product",
      "emailType": "Email",
      "fixedAmountRate": "Fixed Amount Rate",
      "fixedRate": "Fixed Rate",
      "fixedRateHint": "Fixed amount rate, e.g.: 0.50 means 0.50 yuan per transaction",
      "formMode": "Form Mode",
      "formatJson": "Format JSON",
      "help": {
        "channelCode": "Unique code for the payment provider, used to identify the provider in the system, recommended to use alphanumeric and underscore combinations, maximum 100 characters",
        "channelConfig": "Configuration information of the payment provider, supports form mode and JSON mode for editing, used to store provider API keys, merchant numbers and other configuration parameters",
        "channelLogo": "Logo icon of the payment provider, supports uploading image files or using icon library icon identifiers (such as ep:credit-card), recommended size 40x40px, image size not exceeding 1MB",
        "channelName": "Display name of the payment provider, used to identify and display the provider in the system, such as Alipay, WeChat Pay, etc., maximum 100 characters",
        "fixedRate": "Fixed amount rate of the product, for example input 0.50 means 0.50 yuan per transaction, used to calculate transaction fees",
        "orgRequiredParams": "Define parameters that organizations must configure when using this channel, including parameter name, type, description, required status and example value, used to guide organizations to correctly configure channel parameters",
        "percentageRate": "Percentage rate of the product, range 0-100, for example input 0.6 means 0.6%, 1.5 means 1.5%, used to calculate transaction fees",
        "productCode": "Unique code for the provider product, used to identify the product in the system, recommended to use alphanumeric and underscore combinations, maximum 100 characters",
        "productName": "Display name of the provider product, used to identify and display the product in the system, maximum 100 characters"
      },
      "imageSizeLimit": "Image size cannot exceed 1MB!",
      "jsonFormatIncorrect": "JSON format is incorrect",
      "jsonMode": "JSON Mode",
      "jsonType": "JSON",
      "loadDataFailed": "Failed to load data",
      "logoCleared": "Logo cleared",
      "logoHint": "Support image file upload, recommended size: 40x40px",
      "logoLoadFailed": "Logo load failed",
      "logoUploadFailed": "Logo upload failed",
      "logoUploadSuccess": "Logo upload successful",
      "noChannelsDescription": "No payment channels available. Click the \"Add\" button above to create your first payment channel",
      "noConfigItems": "No config items",
      "noProducts": "No products, click \"Add Product\" to create",
      "noRequiredParams": "No required parameters",
      "numberType": "Number",
      "object": "Object",
      "onlyImageFiles": "Only image files can be uploaded!",
      "orgRequiredParams": "Organization Required Parameters",
      "orgRequiredParamsConfig": "Organization Required Parameters Configuration",
      "orgRequiredParamsConfigDesc": "Configure parameters that organizations must fill when using this channel",
      "orgRequiredParamsDesc": "Define parameters that organizations must configure when using this channel",
      "paramDesc": "Parameter Description",
      "paramExample": "Example Value",
      "paramName": "Parameter Name",
      "paramRequired": "Required",
      "paramType": "Parameter Type",
      "parseConfigJsonFailed": "Failed to parse config JSON",
      "percentageRate": "Percentage Rate",
      "percentageRateHint": "Percentage rate range: 0-100, e.g.: 0.6 means 0.6%, 1.5 means 1.5%",
      "percentageRateLabel": "Percentage Rate",
      "productCode": "Product Code",
      "productName": "Product Name",
      "requiredParamAction": "Action",
      "requiredParamDesc": "Parameter Description",
      "requiredParamExample": "Example Value",
      "requiredParamName": "Parameter Name",
      "requiredParamNameExists": "Parameter name already exists",
      "requiredParamRequired": "Required",
      "requiredParamMasked": "Masked",
      "requiredParamType": "Parameter Type",
      "requiredParamValidation": "Parameter name cannot be empty",
      "resetConfig": "Reset Config",
      "searchPlaceholder": "Search Provider name or code...",
      "stringType": "String",
      "submitChannelFailed": "Failed to submit channel",
      "submitProductFailed": "Failed to submit product",
      "title": "Payment Provider Management",
      "updateSuccess": "Updated successfully",
      "uploadResponseFormatError": "Upload response format error",
      "urlType": "URL",
      "validateJson": "Validate JSON",
      "viewConfig": "View Configuration"
    },
    "permissionGroupManagement": {
      "addPermissionGroup": "Add Permission Group",
      "addPermissionGroupDialog": "Add Permission Group",
      "buttonPermissions": "Button Permissions",
      "deletePermissionGroupConfirm": "Are you sure to delete permission group \"{groupName}\"?",
      "editPermissionGroup": "Edit Permission Group",
      "groupName": "Group Name",
      "groupNameLabel": "Permission Group Name",
      "groupType": "Group Type",
      "groupTypeLabel": "Permission Group Type",
      "help": {
        "groupName": "Display name of the permission group, used to identify and display the permission group in the system, 2-60 characters",
        "groupType": "Type identifier of the permission group, used to distinguish different types of permission groups, such as administrator, operator, etc.",
        "remark": "Remarks information of the permission group, used to record the purpose, description or other notes of the permission group",
        "status": "Status of the permission group, enabled permission group will take effect, disabled permission group will be unavailable"
      },
      "loadButtonDataFailed": "Failed to load button data",
      "loadMenuDataFailed": "Failed to load menu data",
      "loadPermissionGroupDataFailed": "Failed to load permission group data",
      "loadPermissionsFailed": "Failed to load permission settings",
      "menuPermissions": "Menu Permissions",
      "noButtonsForMenu": "No button permissions for this menu",
      "permissionGroupList": "Permission Group List",
      "permissionSettings": "Permission Settings",
      "pleaseSelectMenu": "Please select a menu first",
      "pleaseSelectMenuFirst": "Please check the menu first",
      "savePermissions": "Save Permissions",
      "savePermissionsFailed": "Failed to save permissions",
      "savePermissionsSuccess": "Permissions saved successfully",
      "searchPermissionGroup": "Search permission group...",
      "selectPermissionGroupFirst": "Please select a permission group first",
      "statusLabel": "Status",
      "title": "Permission Group Management"
    },
    "platProductManagement": {
      "addProduct": "Add Product",
      "addProductDialog": "Add Platform Business Product",
      "addSuccess": "Product added successfully",
      "associatedChannels": "Associated Channels",
      "availableChannels": "Available Channels",
      "channelAssociationFailed": "Channel association failed",
      "channelAssociationSuccess": "Channel association successful",
      "channelCount": "Channel Count",
      "channelManagementDialog": "Manage Product Channel Association - {productName}",
      "confirmDeleteProductMessage": "Are you sure to delete product \"{productName}\"? This will also delete all channel associations.",
      "deleteFailed": "Failed to delete product",
      "deleteSuccess": "Product deleted successfully",
      "editProduct": "Edit Product",
      "editProductDialog": "Edit Platform Business Product",
      "enterH5Weburl": "Please enter H5 business URL",
      "enterProductCode": "Please enter product code",
      "enterProductName": "Please enter product name",
      "enterRemark": "Please enter remark",
      "h5Weburl": "H5 Business URL",
      "help": {
        "h5Weburl": "H5 business URL path, used for H5 payment scenario business URL address, maximum 60 characters",
        "productCode": "The unique code of the platform business product, used to identify the product in the system, cannot be modified after creation, maximum 50 characters",
        "productName": "The display name of the platform business product, used to identify and display the product in the system, maximum 100 characters",
        "remark": "Product remark information, used to record the purpose, description or other remarks of the product, maximum 256 characters",
        "status": "Product status, enabled products can be used normally, disabled products will be unavailable"
      },
      "loadAssociatedChannelsFailed": "Failed to load associated channels",
      "loadDataFailed": "Failed to load product data",
      "manageChannels": "Manage Channels",
      "noAssociatedChannels": "No associated channels",
      "noAvailableChannels": "No available channels",
      "noChannelsAvailable": "No channels available for association",
      "noChannelsSelected": "No channels selected",
      "noProductsDescription": "No platform business product data, click \"Add\" to create the first product",
      "productCode": "Product Code",
      "productName": "Product Name",
      "relatedChannels": "Related Channels",
      "searchPlaceholder": "Search product code or name...",
      "selectAtLeastOneChannel": "Please select at least one channel",
      "selectChannels": "Select Related Channels",
      "title": "Solution Managment",
      "updateSuccess": "Product updated successfully"
    },
    "qrCodeTransferLog": {
      "endTime": "End Time",
      "enterOperatorName": "Enter operator name",
      "loadDataFailed": "Failed to load QR code transfer records",
      "loadOrgTreeFailed": "Failed to load organization tree",
      "noErrorMessage": "No Error Message",
      "operator": "Operator",
      "orgChange": "Organization Change",
      "selectEndTime": "Select End Time",
      "selectStartTime": "Select Start Time",
      "startTime": "Start Time",
      "transferReason": "Transfer Reason",
      "transferResult": "Transfer Result"
    },
    "qrcodeStickerManagement": {
      "addSticker": "Add Sticker",
      "addStickerDialog": "Add QR Sticker",
      "batchNo": "Batch No.",
      "bound": "Assigned",
      "confirmDeleteMessage": "Are you sure to delete QR sticker \"{qrNo}\"?",
      "confirmUnbind": "Confirm Unassignment",
      "confirmUnbindMessage": "Are you sure you want to unassign QR sticker \"{qrNo}\"? After unassignment, the status will change to Not Assigned.",
      "createBy": "Created By",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Delete successful",
      "detailSectionAudit": "Record",
      "detailSectionDevice": "Linked device",
      "detailSectionMachine": "Assigned Machine",
      "detailSectionSecurity": "Security",
      "deviceType": "Device Type",
      "disabled": "Disabled",
      "editStickerDialog": "Edit QR Sticker",
      "enterQuantity": "Please enter generate quantity",
      "enterTransferRemark": "Enter transfer remark",
      "export": "Export",
      "exportDialog": "Export QR Code",
      "fromOrg": "Source Name",
      "generateQrCodeFailed": "Failed to generate QR code",
      "generateSuccess": "Successfully generated {quantity} QR stickers",
      "help": {
        "createBy": "Created By, used to identify the creator of the QR sticker",
        "createTime": "Create Time, used to identify the creation time of the QR sticker",
        "deviceType": "Device type, used to identify the assigned device type",
        "machineName": "Machine name, used to identify the assigned machine",
        "machineNo": "Machine number, used to identify the assigned machine",
        "machineType": "Machine type, used to identify the assigned machine type",
        "nfcPassword": "NFC password, used for NFC authentication, supports letters and numbers, length 4-16 characters",
        "qrCodeImage": "QR code image generated based on the link address, can be saved as PNG format for printing or display",
        "qrCodeUrl": "Link address corresponding to the QR code, composed of type and QR number, can be copied for access",
        "qrNo": "Unique number of the QR code, automatically generated by the system, used to identify and track QR stickers",
        "quantity": "Number of QR stickers to generate, range 1-1000, the system will batch generate the specified number of QR codes",
        "remark": "Remarks information of the QR sticker, used to record purpose, description or other notes, maximum 255 characters",
        "serialNumber": "Device serial number, used to identify the assigned device",
        "status": "Current status of the QR sticker, including Not Assigned, Assigned and Disabled states",
        "toOrgLabel": "Select the target organization to transfer the QR code to",
        "transferReason": "Transfer reason, explains the reason for QR code transfer, maximum 200 characters",
        "type": "Type of the QR code, selecting different types will generate different link addresses, such as cashier, pre-auth, etc.",
        "updateTime": "Update Time, used to identify the update time of the QR sticker"
      },
      "loadDataFailed": "Failed to load data",
      "loadH5UrlOptionsFailed": "Failed to load H5 URL options",
      "loadOrgTreeFailed": "Failed to load organization tree",
      "loadTransferRecordsFailed": "Failed to load transfer records",
      "machineName": "Machine Name",
      "machineNo": "Machine Number",
      "machineType": "Machine Type",
      "nfcPassword": "NFC Password",
      "noTransferRecords": "No transfer records available",
      "operateTime": "Operation Time",
      "operator": "Operator",
      "orgId": "Organization ID",
      "orgName": "Organization Name",
      "pleaseSelectQrCode": "Please select a QR code first",
      "qrCodeImage": "QR Code",
      "qrCodeUrl": "Link URL",
      "qrNo": "QR Number",
      "qrNoLabel": "QR Number",
      "quantity": "Generate Quantity",
      "quantityRange": "Quantity must be between 1-1000",
      "quantityRequired": "Please enter generate quantity",
      "saveFailed": "Save failed",
      "saveQrCode": "Save QR Code",
      "saveSuccess": "Save successful",
      "searchPlaceholder": "Search QR number or remark...",
      "selectSourceOrg": "Please select source organization",
      "selectStatus": "Select Status",
      "selectTargetOrg": "Please select target organization",
      "selectType": "Select Type",
      "selectTypeFirst": "Please select type first",
      "serialNumber": "SN",
      "statusLabel": "Status",
      "title": "QR Sticker Management",
      "toOrg": "Target Organization Name",
      "toOrgLabel": "Target Name",
      "transfer": "Transfer",
      "transferDialogTitle": "Transfer QR Code",
      "transferFailed": "QR Code Transfer Failed",
      "transferReason": "Transfer reason",
      "transferRecords": "{qrCode} Transfer Records",
      "transferSuccess": "QR Code Transfer Successful",
      "typeCashier": "Cashier",
      "typePreAuth": "Pre-Auth",
      "unbind": "Unassign QR",
      "unbindFailed": "Unassignment failed",
      "unbindSuccess": "Unassignment successful",
      "unbound": "Not Assigned",
      "updateSuccess": "Update successful"
    },
    "systemParameterManagement": {
      "addParameter": "Add Parameter",
      "addParameterDialog": "Add System Parameter",
      "addSuccess": "Added successfully",
      "confirmDeleteMessage": "Are you sure to delete parameter \"{paramName}\"?",
      "deleteFailed": "Delete failed",
      "deleteSuccess": "Deleted successfully",
      "editParameter": "Edit Parameter",
      "editParameterDialog": "Edit System Parameter",
      "help": {
        "paramDesc": "The description of the system parameter, used to explain the purpose, description, or other remarks of this parameter, maximum 255 characters",
        "paramName": "The unique identifier name of the system parameter, used to reference this parameter in the system, cannot be modified after creation, length 1-100 characters",
        "paramValue": "The specific value of the system parameter, which can be a string, number, or other format, length 1-255 characters"
      },
      "loadDataFailed": "Failed to load data",
      "paramDesc": "Parameter Description",
      "paramDescLabel": "Parameter Description",
      "paramName": "Parameter Name",
      "paramNameLabel": "Parameter Name",
      "paramValue": "Parameter Value",
      "paramValueLabel": "Parameter Value",
      "parameter": "Parameter",
      "searchPlaceholder": "Search parameter name or description...",
      "title": "System Parameter Management",
      "updateSuccess": "Updated successfully"
    }
  },
  "timeZoneOptions": {
    "name": {
      "America_Anchorage": "Alaska Time",
      "America_Chicago": "Central Time",
      "America_New_York": "Eastern Time",
      "Pacific_Honolulu": "Hawaii Time",
      "America_Denver": "Mountain Time",
      "America_Los_Angeles": "Pacific Time",
      "America_Halifax": "Atlantic Time",
      "America_Winnipeg": "Central Time",
      "America_Toronto": "Eastern Time",
      "America_Edmonton": "Mountain Time",
      "America_St_Johns": "Newfoundland Time",
      "America_Vancouver": "Pacific Time",
      "America_Mexico_City": "Central Standard Time",
      "America_Monterrey": "Central Standard Time",
      "America_Cancun": "Eastern Standard Time",
      "America_Hermosillo": "Mountain Standard Time",
      "America_Mazatlan": "Mountain Standard Time",
      "America_Tijuana": "Pacific Time",
      "America_Bogota": "Colombia Time",
      "America_Argentina_Buenos_Aires": "Argentina Time",
      "Europe_Vienna": "Central European Time",
      "Europe_London": "Greenwich Mean Time",
      "Asia_Singapore": "Singapore Time",
      "Asia_Shanghai": "China Standard Time"
    },
    "city": {
      "America_Anchorage": "Anchorage",
      "America_Chicago": "Chicago",
      "America_New_York": "New York, Washington",
      "Pacific_Honolulu": "Honolulu",
      "America_Denver": "Denver",
      "America_Los_Angeles": "Los Angeles",
      "America_Halifax": "Halifax",
      "America_Winnipeg": "Winnipeg",
      "America_Toronto": "Toronto",
      "America_Edmonton": "Edmonton",
      "America_St_Johns": "St. John's",
      "America_Vancouver": "Vancouver",
      "America_Mexico_City": "Mexico City",
      "America_Monterrey": "Monterrey",
      "America_Cancun": "Cancun",
      "America_Hermosillo": "Hermosillo",
      "America_Mazatlan": "Mazatlan",
      "America_Tijuana": "Tijuana",
      "America_Bogota": "Bogota",
      "America_Argentina_Buenos_Aires": "Buenos Aires",
      "Europe_Vienna": "Vienna",
      "Europe_London": "London",
      "Asia_Singapore": "Singapore",
      "Asia_Shanghai": "Beijing"
    }
  },
  "tagsView": {
    "closeAll": "Close all",
    "closeOther": "Close other",
    "closeTab": "Close current",
    "closeTheLeftTab": "Close left",
    "closeTheRightTab": "Close right",
    "reload": "Reload"
  }
}
